// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:31:59.239Z
// Property: The Asher (ID: 5745554927648768)
// Collections: 22 amenities, 4 floorplans (live), 28 photos, 82 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5745554927648768",
  "property_external_id": "5015181",
  "property_zillow_url": "https://www.zillow.com/apartments/north-lauderdale-fl/glen-at-cypress-creek/5gBs7t/",
  "property_apartments_url": "https://www.apartments.com/the-asher-north-lauderdale-fl/yyxvqlv",
  "property_google_business_url": "https://www.google.com/maps/place/Glen+at+Cypress+Creek/@26.2039145,-80.1980206,17z/data=!3m1!4b1!4m5!3m4!1s0x88d904725e033f8f:0xbcc64ba5b8565098!8m2!3d26.2039145!4d-80.1958319",
  "property_linkedin_url": null,
  "property_hubspot_id": "8775017869",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-asher",
  "property_name": "The Asher",
  "property_website_url": "https://www.liveattheasher.com/",
  "property_domain": "https://www.liveattheasher.com/",
  "property_address": "1949 Cove Lake Rd",
  "property_full_address": "1949 Cove Lake Rd, North Lauderdale, FL 33068",
  "property_address_1": "1949 Cove Lake Rd",
  "property_address_2": null,
  "property_address_city": "North Lauderdale",
  "property_address_state": "FL",
  "property_address_zip_full": "33068-4637",
  "property_address_zip": "33068",
  "property_address_country": "US",
  "property_address_county": "Broward County",
  "property_neighborhood_address": "Oakland Park",
  "property_address_latitude": "26.2039257",
  "property_address_longitude": "-80.1958983",
  "property_email": "asher@alapts.com",
  "property_phone": "(954) 972-6002",
  "property_call_tracking_phone": "754-285-5556",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lakefront calm, everyday convenience.</strong> Discover pet-friendly one-, two-, and three-bedroom apartments with modern finishes, relaxed outdoor space, and resort-style perks—then explore <a href=\"/floor-plans\">spacious floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> at The Asher.</p>",
  "property_long_description": "<p><strong>Lakefront calm, everyday convenience.</strong> At The Asher, you come home to pet-friendly one-, two-, and three-bedroom apartments in North Lauderdale with modern finishes and a vacation-minded amenity mix. Choose layouts with in-home washers and dryers, granite countertops, stainless steel appliances, tile backsplashes, hardwood-style flooring, walk-in closets, and private patios or balconies, then make the most of a <a href=\"/amenities\">resort-style pool</a> with sundeck, fitness center, BBQ grilling area, volleyball and sports courts, bark park, package lockers, and gated access.</p><p>Set in North Lauderdale’s Oakland Park neighborhood, The Asher keeps you close to the best of central Broward: Hampton Pines Park for lakefront fresh air, Promenade at Coconut Creek for open-air shopping and dining, and Harrah’s Pompano Beach for entertainment. With Florida Medical Center, Keiser University, the Cypress Creek business corridor, Fort Lauderdale Executive Airport, and the beaches of Pompano and Lauderdale-by-the-Sea within easy reach, your routine can feel connected without losing its relaxed South Florida pace. Explore <a href=\"/floor-plans\">spacious floor plans</a> or start with the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-482d-7593-b9e0-90f34e9292aa.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room with a large TV, comfortable sofa, and a scenic view of a lake through the sliding glass doors.",
    "public_id": "019d02f3-482d-7593-b9e0-90f34e9292aa",
    "storage_key": "property/5745554927648768/019d02f3-482d-7593-b9e0-90f34e9292aa.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "224",
  "property_year_built": "1997",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.42857142857143",
  "property_admin_fee": "350",
  "property_application_fee": "125",
  "property_fees_deposit_info": "Application Fee $125\nAdministrative Fee $350\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $499",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8906579.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://theasher.loftliving.com/login",
  "property_apply_now_url": "https://8906579.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-9580-721e-8573-1b708c53b564.webp",
  "property_primary_logo_media": {
    "alt_text": "The Asher Premier Apartments logo with a stylized lotus flower.",
    "public_id": "019e7062-9580-721e-8573-1b708c53b564",
    "storage_key": "property/5745554927648768/019e7062-9580-721e-8573-1b708c53b564.webp",
    "width": 2249,
    "height": 1013
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-958a-7714-989c-05ae653e0da8.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Asher Premier Apartments logo with a lotus flower icon.",
    "public_id": "019e7062-958a-7714-989c-05ae653e0da8",
    "storage_key": "property/5745554927648768/019e7062-958a-7714-989c-05ae653e0da8.webp",
    "width": 2198,
    "height": 952
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-9338-728c-b0a4-d10572a0d8d3.webp",
  "property_icon_media": {
    "alt_text": "Stylized lotus flower logo with green and beige petals on a black background.",
    "public_id": "019e7062-9338-728c-b0a4-d10572a0d8d3",
    "storage_key": "property/5745554927648768/019e7062-9338-728c-b0a4-d10572a0d8d3.webp",
    "width": 854,
    "height": 855
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-9338-728c-b0a4-d10572a0d8d3.webp",
  "property_fav_icon_media": {
    "alt_text": "Stylized lotus flower logo with green and beige petals on a black background.",
    "public_id": "019e7062-9338-728c-b0a4-d10572a0d8d3",
    "storage_key": "property/5745554927648768/019e7062-9338-728c-b0a4-d10572a0d8d3.webp",
    "width": 854,
    "height": 855
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-93e3-73db-a184-16ba347351ee.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Asher Premier Apartments logo",
    "public_id": "019e7062-93e3-73db-a184-16ba347351ee",
    "storage_key": "property/5745554927648768/019e7062-93e3-73db-a184-16ba347351ee.webp",
    "width": 2198,
    "height": 952
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e7062-9362-70ca-9646-05deb14d6c61.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Asher Premier Apartments logo",
    "public_id": "019e7062-9362-70ca-9646-05deb14d6c61",
    "storage_key": "property/5745554927648768/019e7062-9362-70ca-9646-05deb14d6c61.webp",
    "width": 2198,
    "height": 952
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#5d643a",
  "property_secondary_color": "#cbc693",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#d3bfa3",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "760 - 1238",
  "property_sqft_min": "760",
  "property_sqft_max": "1238",
  "property_price_range": "1968.5 - 3225",
  "property_price_min": "1968.5",
  "property_price_max": "3225",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/theasherapartmentsfl",
  "property_instagram_url": "https://www.instagram.com/TheAsherApts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJjz8DXnIE2YgRmFBWuKVLxrw",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-asher-north-lauderdale",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished perks, everyday ease.</strong> The Asher brings comfort into focus with a resort-style pool and sundeck, fitness center, BBQ grilling area, bark park, 24-hour package system, gated access, valet trash, and on-site car care. Inside, one-, two-, and three-bedroom apartments add hardwood-style flooring, granite countertops, stainless steel appliances, in-home washers and dryers, walk-in closets, and private patios or balconies.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to move.</strong> Explore one-, two-, and three-bedroom apartments in North Lauderdale with open living spaces, well-equipped kitchens, and everyday finishes that stand out—granite countertops, stainless steel appliances, tile backsplashes, hardwood-style flooring, in-home washers and dryers, and generous walk-in closets. Select homes also add a private patio or balcony for an easy indoor-outdoor feel.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Asher in focus.</strong> Preview bright interiors, polished kitchens with stainless steel appliances and tile backsplashes, plus living spaces that extend to patios, balconies, or lake-inspired views. The gallery also highlights the sparkling pool and sundeck, fitness center, lounge areas, and green outdoor spaces that shape everyday life in North Lauderdale.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Lauderdale energy, South Florida ease.</strong> At The Asher, McNab Road and Rock Island Road put shopping, casual dining, and daily essentials close by. Unwind at Hampton Pines Park with lakefront trails, picnic areas, and paddleboats, or trade city buzz for Fern Forest Nature Center’s shaded boardwalks. For dinner-and-a-movie plans, The Promenade at Coconut Creek brings open-air restaurants, boutiques, and Silverspot Cinema within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>See why The Asher earns standout reviews.</strong> Residents highlight lake views, spacious-feeling layouts, in-home washers and dryers, clean grounds, and a “warm, welcoming” team. Reviews also praise smooth move-ins, responsive service, and well-kept spaces like the pool, gym, and clubhouse. Read more to get a closer look at everyday life at The Asher.</p>",
  "property_neighborhood_blurb": "<p><strong>Explore the neighborhood around The Asher.</strong> From your North Lauderdale address, you’re positioned near the everyday energy of McNab Road and Rock Island Road, with local shopping, casual eats, and green space close by. Start with Hampton Pines Park for lakefront trails, picnic spots, and paddleboat time, or head toward Fern Forest Nature Center when you want boardwalk scenery and a quieter South Florida reset.</p><p>For nights out, The Promenade at Coconut Creek brings open-air dining, boutiques, and Silverspot Cinema, with favorites like Cooper’s Hawk and Ethos Greek Bistro in the mix. Broward County Transit Route 62 connects the McNab corridor to Cypress Creek Tri-Rail, while nearby US-441 and the Florida Turnpike keep the wider Broward area within easy reach. Use the map to find your next stop, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the location in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity-rich living, without overcomplicating your day.</strong> At The Asher, your routine gets a little more polished—morning workouts in the fitness center, sunny afternoons by the resort-style pool and sundeck, cookouts at the BBQ grilling area, and pickup-ready deliveries through the 24-hour package system. Gated access, valet trash service, online resident tools, and an on-site car care center add practical convenience, while the bark park gives pets their own space to enjoy.</p><p>Inside, one-, two-, and three-bedroom apartments pair hardwood-style flooring with granite countertops, stainless steel appliances, decorative tile backsplashes, in-home washers and dryers, walk-in closets, and private patios or balconies. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready for lakefront calm and everyday convenience?</strong><br>Start your application for a pet-friendly one-, two-, or three-bedroom apartment at The Asher, where modern finishes, private outdoor space, and a resort-minded community setting make it easy to feel at home in North Lauderdale.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The leasing team at The Asher is here to help you explore pet-friendly one-, two-, and three-bedroom apartments in North Lauderdale, from modern finishes to relaxed South Florida convenience. Reach out today and let us point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Asher?</strong> Find quick answers about our pet-friendly one-, two-, and three-bedroom apartments, leasing details, community features, and everyday living in North Lauderdale. If you need anything more, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the space that fits your flow.</strong> The Asher’s North Lauderdale apartments range from efficient one-bedroom layouts to roomier two- and three-bedroom plans, giving you options for the way you cook, unwind, work, and reset. Open living areas connect naturally to well-equipped kitchens, while <a href=\"/amenities\">modern finishes</a> like granite countertops, stainless steel appliances, tile backsplashes, hardwood-style flooring, in-home washers and dryers, and generous walk-in closets add everyday ease. Select the layout that feels right, then picture mornings on a private patio or balcony, simple laundry days at home, and a floor plan that keeps your routine feeling uncluttered. Browse current availability, compare your favorite designs, and <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see the details in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your day at The Asher.</strong> Browse the gallery for a closer look at bright apartment interiors, polished kitchens with stainless steel appliances and tile backsplashes, and living spaces that open toward patios, balconies, or lake-inspired views. The photos move beyond floor plan basics, showing the finishes, natural light, and everyday details that help each home feel considered.</p><p>Step outside in the images and you’ll see why this North Lauderdale apartment community makes a strong impression: a sparkling pool framed by a sundeck, inviting lounge spaces, a fitness center, outdoor gathering areas, and green places to pause between errands or downtime. Explore the photos, compare your favorites with available <a href=\"/floor-plans\">floor plans</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Asher from every angle.</strong> Use the interactive map to browse available apartments and see how this North Lauderdale address connects lakefront calm with everyday convenience, from Oakland Park neighborhood highlights to shopping, dining, entertainment, business corridors, and nearby beaches.</p>",
  "property_pets_blurb": "<p><strong>Pet life feels built in here.</strong> At The Asher, your cat can claim a sunny window and your dog gets more than a quick sidewalk loop, with an on-site Bark Park for daily play, gated grounds for fresh-air strolls, and lake-inspired views that make the routine feel less routine. Inside your apartment, hardwood-style flooring, walk-in closets, and patio or balcony space help keep leashes, toys, and treats comfortably in the mix. When you want to explore beyond home, North Lauderdale places you near local pet services and off-leash outings without turning every errand into a long drive. Review the policy details below, then see more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share lakefront calm and everyday convenience.</strong> Love the modern finishes, pet-friendly floor plans, and vacation-minded amenities at The Asher? Invite a friend to make it home, too—send a referral and let them discover relaxed North Lauderdale living with room to settle in.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made easy.</strong><br>Pay rent, submit maintenance requests, and manage your account from The Asher’s resident portal—so everyday details stay simple, and you can get back to the lakefront calm and connected North Lauderdale convenience that make home feel easy.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents are saying about life at The Asher.</strong> Reviews often point to the details that make everyday living feel easier: spacious-feeling layouts, lake views, in-home washers and dryers, clean grounds, and a team described as “warm, welcoming.”</p><p>Residents also call out the smooth move-in experience, responsive office and maintenance teams, and community events that help create a friendly atmosphere. From relaxing balcony views to well-kept shared spaces like the pool, gym, and clubhouse, the feedback reflects a community where service and setting both stand out. Browse the ratings below to see why many reviewers say The Asher feels like a place they are happy to call home.</p>",
  "property_created_at": "1752256683192",
  "property_scheduletour_blurb": "<p><strong>See lakefront calm up close.</strong> Tour The Asher and picture daily life with modern apartment finishes, private outdoor space, and vacation-minded amenities just beyond your door. Schedule your visit today and find the one-, two-, or three-bedroom layout that feels right.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br> The leasing team at The Asher will follow up soon. In the meantime, picture lakefront calm, pet-friendly apartments, modern finishes, and vacation-minded amenities bringing everyday convenience home in North Lauderdale.</p>",
  "property_virtualtours_blurb": "<p><strong>Take the tour before you make the trip.</strong> Explore The Asher from wherever you are, starting with the community video and Virtual Tour 2, then step inside the clubhouse, fitness center, and pool to get a clearer feel for the spaces you can enjoy day to day. Apartment walkthroughs let you compare the A1 one-bedroom, another one-bedroom tour, and two different two-bedroom layouts without guessing from a flat image. Look for open living areas, bright sliding-glass doors, modern kitchen finishes, walk-in closet storage, and patio or balcony connections that are easier to understand in motion. When a layout catches your eye, compare <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Asher in North Lauderdale up close.</p>",
  "property_copyright": "2025 All Rights Reserved. The Asher",
  "property_seo_title_home": "Home | The Asher",
  "property_seo_description_home": "Experience luxury living at The Asher in North Lauderdale, FL. Enjoy modern amenities, spacious floor plans, and serene lake views. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | North Lauderdale, FL Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Asher in North Lauderdale, FL! Choose from one, two, or three-bedroom floor plans tailored for modern living. Browse now!",
  "property_seo_title_amenities": "Amenities | North Lauderdale, FL Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at The Asher in North Lauderdale, FL. Enjoy resort-style amenities like a lake view pool, fitness center, and dog park. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in North Lauderdale, FL",
  "property_seo_description_gallery": "Experience life at The Asher in North Lauderdale, FL, with stunning views, resort-style amenities, and inviting floor plans. Picture yourself here today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Asher Apartments",
  "property_seo_description_virtualtours": "Experience The Asher in North Lauderdale, FL! Take a virtual tour of our stylish one, two, and three-bedroom apartments and find your perfect fit today!",
  "property_seo_title_interactivemap": "Interactive Map | The Asher Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Asher in North Lauderdale, FL! Use our interactive map to browse floor plans, amenities, and discover your ideal apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in North Lauderdale, FL",
  "property_seo_description_neighborhood": "Uncover local gems and hidden treasures in North Lauderdale, FL! The Asher invites you to explore vibrant neighborhoods and favorites just steps from home.",
  "property_seo_title_contact": "Contact Us | The Asher",
  "property_seo_description_contact": "Connect with The Asher in North Lauderdale! Find your perfect one, two, or three-bedroom apartment. Have questions? Our leasing team is ready to help!",
  "property_seo_title_faqs": "FAQs | Apartments in North Lauderdale, FL",
  "property_seo_description_faqs": "Find answers to your questions about The Asher in North Lauderdale, FL. From amenities to floor plans, we've got you covered. Your home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in North Lauderdale, FL",
  "property_seo_description_reviews": "Experience life at The Asher in North Lauderdale, FL. Check out resident reviews and see why our community with luxe amenities like a resort-style pool shines!",
  "property_seo_title_applynow": "Apply Now | Apartments in North Lauderdale, FL",
  "property_seo_description_applynow": "Live at The Asher in North Lauderdale, FL! Enjoy modern amenities, spacious floor plans, and a resort-style lifestyle. Apply now and claim your ideal home!",
  "property_seo_title_residentaccess": "Resident Access | The Asher",
  "property_seo_description_residentaccess": "Unlock your life at The Asher! Manage rent, request maintenance, and connect with neighbors—all from your convenient resident portal. Your comfort awaits!",
  "property_seo_title_referafriend": "Refer A Friend | The Asher",
  "property_seo_description_referafriend": "Bring your friends home to The Asher in North Lauderdale, FL! Refer a friend today and enjoy a vibrant community where great friendships flourish!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Asher",
  "property_seo_description_scheduletour": "Experience the charm of The Asher in North Lauderdale, FL. Schedule your tour today and see why our vibrant community feels like home!",
  "property_seo_title_privacy": "Privacy Policy | The Asher",
  "property_seo_description_privacy": "At The Asher in North Lauderdale, we value your privacy. Learn how we protect your information and enhance your living experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Asher",
  "property_seo_description_accessibility": "At The Asher in North Lauderdale, FL, we champion digital inclusion. Our accessibility commitment ensures everyone feels at home. Embrace an inclusive community today!",
  "property_seo_title_sitemap": "Sitemap | The Asher",
  "property_seo_description_sitemap": "Uncover your ideal living space at The Asher in North Lauderdale, FL! Navigate our sitemap to find amenities, floor plans, and all that awaits you.",
  "property_seo_title_thankyou": "Thank You | The Asher",
  "property_seo_description_thankyou": "Thank you for reaching out to The Asher in North Lauderdale! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320371",
  "amenities": [
    {
      "id": "custom_b8a3d7a3-b45d-4a89-b75f-56f9a1fccb6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5f5bef8-e71e-4aad-a924-f56a1329dfd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood-Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad9e6320-973d-4017-9fa9-afe1dcfa4c46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000631",
      "title": "Fan",
      "amount": "0.0000",
      "description": "Ceiling Fans*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1dd0a46-fdf4-47cd-8139-ab75a3c7e43a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79fb301b-b831-47dd-a534-f2908c95226c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b72a857-bb58-46e9-a19d-dc4fd8c70f78",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Spacious Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb678ee0-a9a6-43b8-ab48-1a8fd8f01234",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios or Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_622ceaf0-cff6-45ba-b880-7f9a0692c9cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Gated Access Community",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb6e1545-e1b6-4f91-b463-1e10437d5220",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bab60df9-a0dd-492f-b53e-184ff540cb9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000640",
      "title": "Garages",
      "amount": "0.0000",
      "description": "Garages Available",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbe4c6e3-8b76-47f3-ad7b-ff905d0b2738",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16a03113-6ced-4842-b861-9cea4f7ad5c7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f0a563b-d06d-4090-ba4d-063a72e7bb97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd45bd7e-3bcd-4f33-91ed-254fea501cbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "WFH Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f361df5a-7d55-4957-9e3e-3917dd2a2fd7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000002405",
      "title": "Resort Style Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool w/ Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbd4fbe1-6c4c-49c2-abbf-8ac6fdf243cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "24-Hour Resident Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9368fcc-303e-47fd-b3c6-e4d3531d52a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ecd284c-1418-4fb8-8b61-4312d55c4098",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000685",
      "title": "Sports Court",
      "amount": "0.0000",
      "description": "Volleyball & Sports Courts",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aaca6b66-5bd1-44f0-acd8-b511456f7f4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "BBQ Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efe0e11c-05e6-4cc6-9e97-ddf7c55464ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09179eb6-7ce3-4e47-a6ac-5b9715242835",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaf55374-4493-4e34-839c-fba5c938f0b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_45f4e566-43da-4bdb-a62f-437c40359db1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-d21d-778b-a654-0591b08874d3.webp",
      "image_media": {
        "alt_text": "Closet with shelves, hangers, and storage baskets.",
        "public_id": "019e89c6-d21d-778b-a654-0591b08874d3",
        "storage_key": "property/5745554927648768/019e89c6-d21d-778b-a654-0591b08874d3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and storage baskets, perfect for organizing your belongings. Includes a rod for hanging clothes.",
      "link": "",
      "alt_text": "Closet with shelves, hangers, and storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d833be4-89eb-47f8-be15-0d2a3ea48846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-cfc8-739f-87c0-e8bc3bd6e06e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89c6-cfc8-739f-87c0-e8bc3bd6e06e",
        "storage_key": "property/5745554927648768/019e89c6-cfc8-739f-87c0-e8bc3bd6e06e.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fbf315f-321b-4950-87b4-5744e841f446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-c658-7569-9b63-b6a3d4a093b2.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019e89c6-c658-7569-9b63-b6a3d4a093b2",
        "storage_key": "property/5745554927648768/019e89c6-c658-7569-9b63-b6a3d4a093b2.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72f4b0a9-9b3b-40a2-80eb-80d2eaacddc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-cc73-71c8-95ec-a44e2854acef.webp",
      "image_media": {
        "alt_text": "Luxurious lounge area with plush seating and a view of the pool.",
        "public_id": "019e89c6-cc73-71c8-95ec-a44e2854acef",
        "storage_key": "property/5745554927648768/019e89c6-cc73-71c8-95ec-a44e2854acef.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating and elegant decor. Step outside to enjoy the sparkling swimming pool.",
      "link": "",
      "alt_text": "Luxurious lounge area with plush seating and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5411c331-ed6f-4d78-98ef-eb72c07dcde2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-cb60-748c-9bee-66a8be8e5da3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019e89c6-cb60-748c-9bee-66a8be8e5da3",
        "storage_key": "property/5745554927648768/019e89c6-cb60-748c-9bee-66a8be8e5da3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed bathroom, featuring a sleek vanity, modern fixtures, and a clean, inviting bathtub with shower.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a26637c8-23cf-4d79-b2ca-0818875dd3b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-c7cd-73ba-b607-b122b260b1b9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and sleek cabinetry.",
        "public_id": "019e89c6-c7cd-73ba-b607-b122b260b1b9",
        "storage_key": "property/5745554927648768/019e89c6-c7cd-73ba-b607-b122b260b1b9.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Discover a beautifully designed kitchen featuring crisp white countertops, state-of-the-art stainless steel appliances, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and sleek cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13e42e71-eb03-4cf6-a767-a8cafe2bb7ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-cee8-714f-b005-214c8a6892ab.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer",
        "public_id": "019e89c6-cee8-714f-b005-214c8a6892ab",
        "storage_key": "property/5745554927648768/019e89c6-cee8-714f-b005-214c8a6892ab.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "In-unit laundry room featuring a washer and dryer, with decorative artwork on the wall.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14e52ba8-ef57-4afa-8409-2249a507bdef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-c213-72b8-8eae-7f7f716b2596.webp",
      "image_media": {
        "alt_text": "Modern conference room with a large black table, chairs, and abstract art.",
        "public_id": "019e89c6-c213-72b8-8eae-7f7f716b2596",
        "storage_key": "property/5745554927648768/019e89c6-c213-72b8-8eae-7f7f716b2596.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Host your next meeting in our stylish conference room, featuring a large table, comfortable seating, and elegant decor. Perfect for business or social gatherings.",
      "link": "",
      "alt_text": "Modern conference room with a large black table, chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_326d6c82-73c4-415f-9254-be80c717b2c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-c02f-715a-8b0c-50e9943774b0.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, dark gray headboard, and decorative pillows.",
        "public_id": "019e89c6-c02f-715a-8b0c-50e9943774b0",
        "storage_key": "property/5745554927648768/019e89c6-c02f-715a-8b0c-50e9943774b0.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, plush bedding, and modern decor for a tranquil retreat.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, dark gray headboard, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0790fbe8-e25d-498f-a7a5-b5e677012401",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-b6ae-7206-9cde-f2999414d5c3.webp",
      "image_media": {
        "alt_text": "Balcony overlooking a lake with apartments in the background.",
        "public_id": "019e89c6-b6ae-7206-9cde-f2999414d5c3",
        "storage_key": "property/5745554927648768/019e89c6-b6ae-7206-9cde-f2999414d5c3.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy serene lake views from your private balcony, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Balcony overlooking a lake with apartments in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_386ee9aa-d5a7-482a-9d66-44979c84d3e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-bbd4-73ee-928e-62285a9e58d2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with palm trees and manicured lawns.",
        "public_id": "019e89c6-bbd4-73ee-928e-62285a9e58d2",
        "storage_key": "property/5745554927648768/019e89c6-bbd4-73ee-928e-62285a9e58d2.webp",
        "width": 2189,
        "height": 1460
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring lush green landscaping, palm trees, and well-maintained grounds. Offers a serene and tropical living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment building with palm trees and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8ba0dcf-9741-4780-88a4-d9d218c2f822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-b6a6-709b-8b46-9ae77e5b87cd.webp",
      "image_media": {
        "alt_text": "Sunny poolside with lounge chairs and umbrellas overlooking a large swimming pool and building.",
        "public_id": "019e89c6-b6a6-709b-8b46-9ae77e5b87cd",
        "storage_key": "property/5745554927648768/019e89c6-b6a6-709b-8b46-9ae77e5b87cd.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Enjoy the beautiful weather and unwind in this tranquil oasis.",
      "link": "",
      "alt_text": "Sunny poolside with lounge chairs and umbrellas overlooking a large swimming pool and building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f8240fa-891f-459c-9a4e-6fe743b91cdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-b792-77ef-891f-96f902a49d6f.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances and quartz countertops.",
        "public_id": "019e89c6-b792-77ef-891f-96f902a49d6f",
        "storage_key": "property/5745554927648768/019e89c6-b792-77ef-891f-96f902a49d6f.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, quartz countertops, and ample cabinet space. Includes washer and dryer.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e215fdfd-bc72-4546-aefb-6c397600bb38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-ad56-735c-b4a3-84a3bd9b71b6.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with sofas and tables next to a swimming pool.",
        "public_id": "019e89c6-ad56-735c-b4a3-84a3bd9b71b6",
        "storage_key": "property/5745554927648768/019e89c6-ad56-735c-b4a3-84a3bd9b71b6.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable seating and a refreshing swimming pool just steps away.",
      "link": "",
      "alt_text": "Outdoor seating area with sofas and tables next to a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e50e82e2-826a-43cd-b08a-1dc2ce7b3d1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-ada0-7552-a524-4972fbe46b7b.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, dark accent wall, and patio access.",
        "public_id": "019e89c6-ada0-7552-a524-4972fbe46b7b",
        "storage_key": "property/5745554927648768/019e89c6-ada0-7552-a524-4972fbe46b7b.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable queen-size bed, elegant decor, and direct access to your private patio.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, dark accent wall, and patio access.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_932654f4-34cc-4a47-baea-802087584b48",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-a124-76a9-b84c-37acb2370e66.webp",
      "image_media": {
        "alt_text": "A staged living room with a gray sofa, ottoman, and a large window overlooking a lake.",
        "public_id": "019e89c6-a124-76a9-b84c-37acb2370e66",
        "storage_key": "property/5745554927648768/019e89c6-a124-76a9-b84c-37acb2370e66.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush gray sofa, textured ottoman, and modern decor, with a scenic view of the lake through a large sliding glass door.",
      "link": "",
      "alt_text": "A staged living room with a gray sofa, ottoman, and a large window overlooking a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ceeee11b-47db-484a-bb3f-b32098b7f16e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-a146-737a-aabc-c2d7d885a1c5.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
        "public_id": "019e89c6-a146-737a-aabc-c2d7d885a1c5",
        "storage_key": "property/5745554927648768/019e89c6-a146-737a-aabc-c2d7d885a1c5.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with treadmills, ellipticals, and weight machines to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_589e2533-488a-4d40-bb18-4bac0897c7bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-9409-73ef-90cb-f4cc199412e2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019e89c6-9409-73ef-90cb-f4cc199412e2",
        "storage_key": "property/5745554927648768/019e89c6-9409-73ef-90cb-f4cc199412e2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright kitchen featuring contemporary finishes, ample counter space, and a full suite of stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9f5536ee-0372-4077-8385-c88414bb5fcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-a6ff-7379-8d23-d7fdc7bd9a90.webp",
      "image_media": {
        "alt_text": "Dining area with a table set for four, open to a living room with a sofa and view of the kitchen.",
        "public_id": "019e89c6-a6ff-7379-8d23-d7fdc7bd9a90",
        "storage_key": "property/5745554927648768/019e89c6-a6ff-7379-8d23-d7fdc7bd9a90.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a stylish dining area seamlessly flowing into a spacious living room and a modern kitchen.",
      "link": "",
      "alt_text": "Dining area with a table set for four, open to a living room with a sofa and view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d8081df-f4a4-4483-8ec1-09b15b1f07e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-958a-77fd-9d92-c9afeeebd261.webp",
      "image_media": {
        "alt_text": "Lobby with plush seating and view of the outdoor pool.",
        "public_id": "019e89c6-958a-77fd-9d92-c9afeeebd261",
        "storage_key": "property/5745554927648768/019e89c6-958a-77fd-9d92-c9afeeebd261.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax in our stylish lobby, featuring comfortable seating and a view of the sparkling outdoor pool. The perfect place to unwind.",
      "link": "",
      "alt_text": "Lobby with plush seating and view of the outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78a0f71e-2146-44fe-9c41-4c96b2a64482",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-93fa-77cf-b043-5080ed835254.webp",
      "image_media": {
        "alt_text": "Lobby seating area with plush sofas, chairs, and coffee tables, overlooking a pool.",
        "public_id": "019e89c6-93fa-77cf-b043-5080ed835254",
        "storage_key": "property/5745554927648768/019e89c6-93fa-77cf-b043-5080ed835254.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring comfortable seating and elegant decor. Step outside to enjoy the sparkling swimming pool.",
      "link": "",
      "alt_text": "Lobby seating area with plush sofas, chairs, and coffee tables, overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28435d5c-ad39-4755-aafd-5d3732729b00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-8f06-77bc-92db-3f4c3901c456.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, stainless steel faucet, and dark teal shower curtain.",
        "public_id": "019e89c6-8f06-77bc-92db-3f4c3901c456",
        "storage_key": "property/5745554927648768/019e89c6-8f06-77bc-92db-3f4c3901c456.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our modern bathrooms, featuring elegant finishes and ample counter space for your convenience.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, stainless steel faucet, and dark teal shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a45165e-bec9-40a1-b326-8dd31595bd4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-8ef3-761d-a723-d4225ed22c3d.webp",
      "image_media": {
        "alt_text": "Apartment buildings line a serene lake under a bright blue sky with scattered clouds.",
        "public_id": "019e89c6-8ef3-761d-a723-d4225ed22c3d",
        "storage_key": "property/5745554927648768/019e89c6-8ef3-761d-a723-d4225ed22c3d.webp",
        "width": 2189,
        "height": 1460
      },
      "title": "Community",
      "description": "Experience lakeside living with stunning views of the water and lush landscaping surrounding the apartment buildings.",
      "link": "",
      "alt_text": "Apartment buildings line a serene lake under a bright blue sky with scattered clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6572a399-5d11-4109-9718-6d040a62dd76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-92bd-746b-a38a-a3978d7efa10.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e89c6-92bd-746b-a38a-a3978d7efa10",
        "storage_key": "property/5745554927648768/019e89c6-92bd-746b-a38a-a3978d7efa10.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9ac8b8ff-6cda-40ec-b00b-d934391ae85e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-8f79-7735-ad81-ac422c0e872c.webp",
      "image_media": {
        "alt_text": "Modern living room with large gray sectional, abstract art, and balcony overlooking water.",
        "public_id": "019e89c6-8f79-7735-ad81-ac422c0e872c",
        "storage_key": "property/5745554927648768/019e89c6-8f79-7735-ad81-ac422c0e872c.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring a comfortable sectional, modern decor, and stunning views from the balcony.",
      "link": "",
      "alt_text": "Modern living room with large gray sectional, abstract art, and balcony overlooking water.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_25479731-400a-4522-8375-032cc8d3fa04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-8d72-73ac-b87e-493399a61acd.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with wire shelving and black hangers.",
        "public_id": "019e89c6-8d72-73ac-b87e-493399a61acd",
        "storage_key": "property/5745554927648768/019e89c6-8d72-73ac-b87e-493399a61acd.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Ample storage space in this walk-in closet, featuring adjustable wire shelving and organized hangers. Perfect for keeping your belongings tidy.",
      "link": "",
      "alt_text": "Spacious walk-in closet with wire shelving and black hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0578112f-4784-4aa7-9c3e-757088236ebe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-7a83-7551-9208-4776d93d75d1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with a built-in grill, trash can, and a table with chairs under an umbrella.",
        "public_id": "019e89c6-7a83-7551-9208-4776d93d75d1",
        "storage_key": "property/5745554927648768/019e89c6-7a83-7551-9208-4776d93d75d1.webp",
        "width": 2688,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with our convenient grilling station, complete with a spacious grill, seating area, and umbrella for shade.",
      "link": "",
      "alt_text": "Outdoor grilling station with a built-in grill, trash can, and a table with chairs under an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_817fe4a9-1a9f-4053-9545-0c78efd004c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019e89c6-7924-77d5-b7c8-859e440a32ec.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and lake.",
        "public_id": "019e89c6-7924-77d5-b7c8-859e440a32ec",
        "storage_key": "property/5745554927648768/019e89c6-7924-77d5-b7c8-859e440a32ec.webp",
        "width": 2189,
        "height": 1460
      },
      "title": "Community",
      "description": "Experience resort-style living with our sparkling pool, lush landscaping, and serene lake views. Your perfect oasis awaits.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_84edb459b10dafa55f1db4fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Tabanka A Trini Kitchen Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1645 S State Rd 7, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Casual restaurant specializing in Caribbean comfort foods, including bake and shark, doubles, and roti.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-f3c8-74d7-8db4-30e77f26a6fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-f3c8-74d7-8db4-30e77f26a6fb",
        "storage_key": "property/5745554927648768/019f14f8-f3c8-74d7-8db4-30e77f26a6fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=70584515730563447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tabanka-a-trini-kitchen-restaurant",
      "poi_latitude": "26.2065121",
      "poi_longitude": "-80.2045821",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-933-1307",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtT3HYJAF2YgRd2HDOj7E-gA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "caribbean_restaurant"
    },
    {
      "id": "ec_839095eef01565a9488bcf83",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Rootz Soul Café",
      "poi_type": "Restaurants",
      "poi_address": "1651 S State Rd 7, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Plant-based eatery offering burgers, tacos and other comfort foods, plus take-out cuisine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-ef71-7765-b3be-a66231d14eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-ef71-7765-b3be-a66231d14eb1",
        "storage_key": "property/5745554927648768/019f14f8-ef71-7765-b3be-a66231d14eb1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.rootzsoulcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326694282206753377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rootz-soul-caf",
      "poi_latitude": "26.2063668",
      "poi_longitude": "-80.2045797",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 954-597-6202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9eeXTsF2YgRYbI1PFVcjnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vegan_restaurant"
    },
    {
      "id": "ec_2f44ca4ba5cae4ff54b0e323",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "REGGAE PON THE GRILLE",
      "poi_type": "Restaurants",
      "poi_address": "8032 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Casual spot serving traditional Jamaican cuisine for breakfast, lunch, and dinner, with live music.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-f2a8-70ec-b767-b56950e46e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-f2a8-70ec-b767-b56950e46e84",
        "storage_key": "property/5745554927648768/019f14f8-f2a8-70ec-b767-b56950e46e84.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://food.orders.co/reggaeponthegrille",
      "poi_directions_map_url": "https://maps.google.com/?cid=11522641815772851078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reggae-pon-the-grille",
      "poi_latitude": "26.2074185",
      "poi_longitude": "-80.2346287",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 754-220-8738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwuWB7UF2YgRhuszj66l6J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_ac2bde1f9e58583dc040c60c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Island Flavor Cafe",
      "poi_type": "Restaurants",
      "poi_address": "7958 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Casual spot serving Jamaican standards like jerk chicken and brown stew as well as seafood dishes, along with soups and rice.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-e619-744d-a440-7dd22642f5c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-e619-744d-a440-7dd22642f5c5",
        "storage_key": "property/5745554927648768/019f14f8-e619-744d-a440-7dd22642f5c5.webp",
        "width": 711,
        "height": 666
      },
      "poi_business_url": "http://islandflavorcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8470370711745051389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "island-flavor-cafe",
      "poi_latitude": "26.2064215",
      "poi_longitude": "-80.2314443",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-597-6083",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs3LW0GAF2YgR_bpvzUjNjHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_9e91b0b6c1c2c3ee0f739c02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Taste Rite Jamaican Bakery",
      "poi_type": "Restaurants",
      "poi_address": "8028 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Bakery specializing in Jamaican-style patties and coco bread, along with pastries and soups.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-ea6a-700b-8650-72c8682a7e50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-ea6a-700b-8650-72c8682a7e50",
        "storage_key": "property/5745554927648768/019f14f8-ea6a-700b-8650-72c8682a7e50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15744847538756535672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taste-rite-jamaican-bakery",
      "poi_latitude": "26.2075037",
      "poi_longitude": "-80.23462099999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 754-307-9401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAf5CV7QF2YgReEVErmrvgNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_f394fbc06b2f501f654c3058",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "China Garden Chinese restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7954 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Egg rolls, bourbon chicken, and other classic Chinese dishes round out the menu at this informal joint.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-ed77-753e-96b0-0ad8cff9cc81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-ed77-753e-96b0-0ad8cff9cc81",
        "storage_key": "property/5745554927648768/019f14f8-ed77-753e-96b0-0ad8cff9cc81.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.chinagardenmcnab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4495408523960590597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-garden-chinese-restaurant",
      "poi_latitude": "26.2064621",
      "poi_longitude": "-80.23137059999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-590-3375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2-Wc8oF2YgRBSHvHjzmYj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_028af680ad9a1fe4f806ab7f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Pollo Tropical",
      "poi_type": "Restaurants",
      "poi_address": "8096 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Counter-serve chain for Caribbean grilled chicken & pork platters, sandwiches & more.",
      "poi_long_description": "Counter-serve chain for Caribbean grilled chicken & pork platters, sandwiches & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-ed8c-70da-bd43-c67a5d03fc18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-ed8c-70da-bd43-c67a5d03fc18",
        "storage_key": "property/5745554927648768/019f14f8-ed8c-70da-bd43-c67a5d03fc18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pollotropical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11121613080138068409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pollo-tropical",
      "poi_latitude": "26.207875",
      "poi_longitude": "-80.2359585",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 954-721-2497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxGZTbQF2YgRubH36ivoV5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "ec_870523c651d46a60d045fc51",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "La Costa Rock Island Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7210 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-e876-7010-b3e1-641f5ec8c85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-e876-7010-b3e1-641f5ec8c85a",
        "storage_key": "property/5745554927648768/019f14f8-e876-7010-b3e1-641f5ec8c85a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lacostaolasrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14459084010604458161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-costa-rock-island-restaurant",
      "poi_latitude": "26.206384",
      "poi_longitude": "-80.221525",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-388-5917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH2PNawAF2YgRsfCb1Uz8qMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_f4bd2f1ae03127c71d999107",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "La Brasa Grill - North Lauderdale",
      "poi_type": "Restaurants",
      "poi_address": "7730 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Laid-back eatery for rotisserie chicken, seafood and steaks, plus bowls and takeout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-e6db-71d3-88d5-58105ba7d1d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-e6db-71d3-88d5-58105ba7d1d6",
        "storage_key": "property/5745554927648768/019f14f8-e6db-71d3-88d5-58105ba7d1d6.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://labrasagrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8104176343442210338&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-brasa-grill---north-lauderdale",
      "poi_latitude": "26.2076982",
      "poi_longitude": "-80.2300166",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 754-666-4943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt38X_PwF2YgRIj7_U3LRd3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_60a8a0cbe5245314372035d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Dutch Pot Restaurant - North Lauderdale",
      "poi_type": "Restaurants",
      "poi_address": "6029 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Casual restaurant chain serving traditional Jamaican meals for breakfast, lunch, and dinner.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-f1ee-72ed-8423-a5e8821f4368.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-f1ee-72ed-8423-a5e8821f4368",
        "storage_key": "property/5745554927648768/019f14f8-f1ee-72ed-8423-a5e8821f4368.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchpotrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18366425633760180501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-pot-restaurant---north-lauderdale",
      "poi_latitude": "26.2166123",
      "poi_longitude": "-80.2055879",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-979-1915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76oMq1cF2YgRFXnn7c2m4v4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_26c649a5d27838ee807442c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Charleys Cheesesteaks",
      "poi_type": "Restaurants",
      "poi_address": "7202 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Counter-service chain offering a range of Philly-style cheesesteaks, loaded fries & lemonades.",
      "poi_long_description": "Counter-service chain offering a range of Philly-style cheesesteaks, loaded fries & lemonades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-f417-72e0-9efb-9ca756b690df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-f417-72e0-9efb-9ca756b690df",
        "storage_key": "property/5745554927648768/019f14f8-f417-72e0-9efb-9ca756b690df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.charleys.com/menu/arena-shoppes/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4273246644994358733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charleys-cheesesteaks",
      "poi_latitude": "26.207752",
      "poi_longitude": "-80.22205149999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-366-3245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7-TZJUF2YgRzb2E2C6fTTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_99ce308a2f755f22260f5106",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Papa Johns Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8016 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Pizza take-out & delivery chain offering classic & specialty pizzas, plus wings, sides & desserts.",
      "poi_long_description": "Pizza take-out & delivery chain offering classic & specialty pizzas, plus wings, sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-00c2-70af-aa76-8c09a784e5c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-00c2-70af-aa76-8c09a784e5c6",
        "storage_key": "property/5745554927648768/019f14f9-00c2-70af-aa76-8c09a784e5c6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.papajohns.com/united-states/fl/33068/north-lauderdale/8016-west-mcnab-road?utm_source=gmb&utm_medium=organic&y_source=1_MTA2OTM2MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496142541549794875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papa-johns-pizza",
      "poi_latitude": "26.2077894",
      "poi_longitude": "-80.2344817",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-726-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWJ7V7QF2YgRO_bE3uylB2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_2f748777e8e5e53b3222083d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "7135 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-fd2f-74bf-8ec2-5f1bc4ed784e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-fd2f-74bf-8ec2-5f1bc4ed784e",
        "storage_key": "property/5745554927648768/019f14f8-fd2f-74bf-8ec2-5f1bc4ed784e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/fl/north-lauderdale/7135-w-mcnab-rd/336907?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=336907&y_source=1_MTIxMTExMTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6789890151418307398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "26.2091455",
      "poi_longitude": "-80.22190619999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 754-324-5851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73c8-7755-84b7-a918e81c1c65.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73c8-7755-84b7-a918e81c1c65",
        "storage_key": "property/5745554927648768/019f14f9-73c8-7755-84b7-a918e81c1c65.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJJSJbEEYE2YgRRiM2Sx6JOl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_e616aacb90f8e5cf29cd0495",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Flanigan's Seafood Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "5450 FL-7, Fort Lauderdale, FL 33319, USA",
      "poi_short_description": "American eats & seafood are served at this local chain restaurant & sports bar with plenty of TVs.",
      "poi_long_description": "American eats & seafood are served at this local chain restaurant & sports bar with plenty of TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f8-fa14-7074-a93e-8d68f4f7edc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f8-fa14-7074-a93e-8d68f4f7edc7",
        "storage_key": "property/5745554927648768/019f14f8-fa14-7074-a93e-8d68f4f7edc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://flanigans.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7110080430252839793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flanigans-seafood-bar-and-grill",
      "poi_latitude": "26.1935825",
      "poi_longitude": "-80.2032083",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-733-0514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d8-73ed-9f2d-0ca15a664423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d8-73ed-9f2d-0ca15a664423",
        "storage_key": "property/5745554927648768/019f14f9-73d8-73ed-9f2d-0ca15a664423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr5QoBJep2YgRcVOtAXsUrGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_e3c615720621610f0acaa54f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "7105 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-09fb-7474-b445-7901797e1ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-09fb-7474-b445-7901797e1ecb",
        "storage_key": "property/5745554927648768/019f14f9-09fb-7474-b445-7901797e1ecb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wawa.com/locations/5372?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=9945393281868389935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "26.2093243",
      "poi_longitude": "-80.2208939",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 754-732-3899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6a-7717-a12e-b2403b94173c",
        "storage_key": "property/5745554927648768/019d02f3-df6a-7717-a12e-b2403b94173c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtVuATd0F2YgRL15SNX8iBYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_07c3df8c8762299d0118834d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8100 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0420-70bd-840d-d29e7ed4bca8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0420-70bd-840d-d29e7ed4bca8",
        "storage_key": "property/5745554927648768/019f14f9-0420-70bd-840d-d29e7ed4bca8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.7-eleven.com/locations/fl/north-lauderdale/8100-w-mcnab-rd-34827?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3773877100344178235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "26.207941",
      "poi_longitude": "-80.23683779999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-721-3354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73ca-70ab-8e6b-a5eba2101403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73ca-70ab-8e6b-a5eba2101403",
        "storage_key": "property/5745554927648768/019f14f9-73ca-70ab-8e6b-a5eba2101403.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJb5VOvG0E2YgRO_b-VzqBXzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_c7791969c640a761814a88b6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7900 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Large big-box chain stocking a wide range of items like toys, electronics, home goods and clothing in a bright space with groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0a0d-75ff-9d23-54a8ccdf1a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0a0d-75ff-9d23-54a8ccdf1a0a",
        "storage_key": "property/5745554927648768/019f14f9-0a0d-75ff-9d23-54a8ccdf1a0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/1851-north-lauderdale-fl/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17409253116798457399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "26.2052519",
      "poi_longitude": "-80.2297667",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-726-3388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df98-7550-ae2e-17fe42f15b07",
        "storage_key": "property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc8jhwrQF2YgRN1ait3gXmvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_dff6614a687716e0f660a059",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Publix Super Market at The Shoppes at Western Woods",
      "poi_type": "Shopping & Retail",
      "poi_address": "8140 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0b28-73d6-a09b-50514ae4af65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0b28-73d6-a09b-50514ae4af65",
        "storage_key": "property/5745554927648768/019f14f9-0b28-73d6-a09b-50514ae4af65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=822&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=1137355802615489719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-the-shoppes-at-western-woods",
      "poi_latitude": "26.206272",
      "poi_longitude": "-80.2369508",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-722-0599",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e022-73b6-b956-825de3c3e4f4",
        "storage_key": "property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-pOvG0E2YgRtyQglhOzyA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_176aa0aba2935d63641ea348",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1180 S State Rd 7, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-1368-751b-9090-8adb072e8e36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-1368-751b-9090-8adb072e8e36",
        "storage_key": "property/5745554927648768/019f14f9-1368-751b-9090-8adb072e8e36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/fl/north-lauderdale/1180-s-state-road-7/fa45",
      "poi_directions_map_url": "https://maps.google.com/?cid=4183212152185225906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "26.214169",
      "poi_longitude": "-80.203621",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e022-73b6-b956-825de3c3e4f4",
        "storage_key": "property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6S_AmFoF2YgRsgIZ70nBDTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_37da98ce18f6e9f3f4c65130",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Key Food Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "6039 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Chain offering groceries & household goods, such as cleaning supplies & beauty products.",
      "poi_long_description": "Chain offering groceries & household goods, such as cleaning supplies & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0b3a-70ad-9991-88a2eb1950c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0b3a-70ad-9991-88a2eb1950c8",
        "storage_key": "property/5745554927648768/019f14f9-0b3a-70ad-9991-88a2eb1950c8.webp",
        "width": 1280,
        "height": 742
      },
      "poi_business_url": "https://www.keyfood.com/store/store/4332?distance=1.23%20miles&query=&radius=5&services=",
      "poi_directions_map_url": "https://maps.google.com/?cid=7871329354256207081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "key-food-supermarkets",
      "poi_latitude": "26.2161126",
      "poi_longitude": "-80.20604589999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-970-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e022-73b6-b956-825de3c3e4f4",
        "storage_key": "property/5745554927648768/019d02f3-e022-73b6-b956-825de3c3e4f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7dfVOWYE2YgR6cyL9leUPG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_126be3daa3450a69443ea0fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1195 S State Rd 7, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0690-71a8-b763-ea32b5c0ad39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0690-71a8-b763-ea32b5c0ad39",
        "storage_key": "property/5745554927648768/019f14f9-0690-71a8-b763-ea32b5c0ad39.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/North-Lauderdale/FL/North-Lauderdale/33068/6312?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16658552399871682871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "26.2142586",
      "poi_longitude": "-80.2055594",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-971-2743",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df98-7550-ae2e-17fe42f15b07",
        "storage_key": "property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ74VloWgE2YgRNymVmiURL-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_4012e917888542bf99550ea5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3915 W Commercial Blvd, Tamarac, FL 33309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0994-718e-8a83-e79e1a6e0a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0994-718e-8a83-e79e1a6e0a46",
        "storage_key": "property/5745554927648768/019f14f9-0994-718e-8a83-e79e1a6e0a46.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tamarac-fl-pharmacies/3915-w-commercial-blvd-tamarac-fl-33309/storeid=990?WT.mc_id=LS_GOOGLE_RX_990",
      "poi_directions_map_url": "https://maps.google.com/?cid=8742710258709282220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "26.187365",
      "poi_longitude": "-80.2029397",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-733-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d3-76cc-b4e3-d5a9cfd0daba",
        "storage_key": "property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_XsyRsE2YgRrL2H0KhYVHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_54708b5a2833c7fa26457b31",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "1190 S State Rd 7, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Spacious convenience store and gas station featuring pizza and wings alongside sodas and fro-yo.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0f31-7716-b6f5-27d711eba56c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0f31-7716-b6f5-27d711eba56c",
        "storage_key": "property/5745554927648768/019f14f9-0f31-7716-b6f5-27d711eba56c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/north-lauderdale/1190-s-sr-7/2707643?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7207378546071030718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "26.2133651",
      "poi_longitude": "-80.2036664",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 954-973-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73ca-70ab-8e6b-a5eba2101403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73ca-70ab-8e6b-a5eba2101403",
        "storage_key": "property/5745554927648768/019f14f9-73ca-70ab-8e6b-a5eba2101403.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJBzNfTG8E2YgRvstV8JnABWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_74088d455c6684cf2170162b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "North Lauderdale Elementary",
      "poi_type": "Education",
      "poi_address": "7500 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.browardschools.com/northlauderdale",
      "poi_directions_map_url": "https://maps.google.com/?cid=15806328766005499050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-lauderdale-elementary",
      "poi_latitude": "26.2171208",
      "poi_longitude": "-80.2260127",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 754-322-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsYDv-FEE2YgRqtTLZERcW9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_366391ad69cd94df0354076b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Pinewood Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 SW 83rd Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-1117-74ee-96ab-f15cf9aea135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-1117-74ee-96ab-f15cf9aea135",
        "storage_key": "property/5745554927648768/019f14f9-1117-74ee-96ab-f15cf9aea135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.browardschools.com/pinewood",
      "poi_directions_map_url": "https://maps.google.com/?cid=13199903745179668874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinewood-elementary-school",
      "poi_latitude": "26.2065542",
      "poi_longitude": "-80.2389397",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 754-322-7950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnVfabLYF2YgRilHIKIV6L7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_190f95e2c6bd782159787b95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Morrow Elementary School",
      "poi_type": "Education",
      "poi_address": "408 SW 76th Terrace, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://morrow.browardschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13063954622949178555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morrow-elementary-school",
      "poi_latitude": "26.2248028",
      "poi_longitude": "-80.228123",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 754-322-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkaH4yVUE2YgRuzy1hoN9TLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c3f65683fdc542f62171aaf8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Silver Lakes Middle School",
      "poi_type": "Education",
      "poi_address": "7600 Tam Oshanter Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-1486-740b-afe1-8cc09f420dd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-1486-740b-afe1-8cc09f420dd6",
        "storage_key": "property/5745554927648768/019f14f9-1486-740b-afe1-8cc09f420dd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://silverlakes.browardschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10452768426632963730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "silver-lakes-middle-school",
      "poi_latitude": "26.2137696",
      "poi_longitude": "-80.2270774",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 754-322-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ4TR_FEE2YgRkmbgvICxD5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_faa513a6cf85a011f03921d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Somerset Preparatory Academy Charter School at North Lauderdale",
      "poi_type": "Education",
      "poi_address": "7101 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-1cbb-720f-9362-e7d7d60d258e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-1cbb-720f-9362-e7d7d60d258e",
        "storage_key": "property/5745554927648768/019f14f9-1cbb-720f-9362-e7d7d60d258e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.somersetprep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14169671650684062487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerset-preparatory-academy-charter-school-at-north-lauderdale",
      "poi_latitude": "26.2191021",
      "poi_longitude": "-80.2208902",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-718-5065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSwzveVoE2YgRF0vyykrJpMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_30359b171e5ab2957981a61c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broadview Children's Center",
      "poi_type": "Education",
      "poi_address": "1880 SW 62nd Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6656905187961809508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadview-childrens-center",
      "poi_latitude": "26.2036316",
      "poi_longitude": "-80.2067644",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-975-5373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiWwKJmsE2YgRZCrrp_8TYlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a63255f47d53ed08902882c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Kimberly Boulevard KinderCare",
      "poi_type": "Education",
      "poi_address": "7460 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-11cc-75fc-bd1b-d494ff203580.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-11cc-75fc-bd1b-d494ff203580",
        "storage_key": "property/5745554927648768/019f14f9-11cc-75fc-bd1b-d494ff203580.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/north-lauderdale/fl/300725?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MzI1LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=5044068578262162438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimberly-boulevard-kindercare",
      "poi_latitude": "26.2171352",
      "poi_longitude": "-80.2249727",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-721-7520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDeR5v1EE2YgRBpwGtqUhAEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_7272fbc03f49777d3541138b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Family Center International Academy",
      "poi_type": "Education",
      "poi_address": "840 SW 81st Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Daycare offering a range of educational activities and a play area, plus clean facilities. Friendly staff provide 24/7 supervision in a family environment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-13d4-71bf-ae44-6631d9a59d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-13d4-71bf-ae44-6631d9a59d73",
        "storage_key": "property/5745554927648768/019f14f9-13d4-71bf-ae44-6631d9a59d73.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://winnie.com/place/family-center-international-academy-pompano-beach?fbclid=IwZXh0bgNhZW0CMTAAAR2eNZMa1e0feBAgUGhic2T_DF-HxhSP3835_r4_YGrmH2oEztCQOyplsx8_aem_vuG2NoEOsa0pdoazPhzNjQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=1379081452900976546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-center-international-academy",
      "poi_latitude": "26.2186268",
      "poi_longitude": "-80.2360088",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 954-546-8604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVQdUfbgF2YgRogd-VEZ7IxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2350eb67676a450506f774d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Buttons and Bows Academy",
      "poi_type": "Education",
      "poi_address": "963 SW 71st Ave, Pompano Beach, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-1ba8-774e-a018-3f87abfd9df1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-1ba8-774e-a018-3f87abfd9df1",
        "storage_key": "property/5745554927648768/019f14f9-1ba8-774e-a018-3f87abfd9df1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://buttonsandbowsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7418322576469491636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buttons-and-bows-academy",
      "poi_latitude": "26.2165641",
      "poi_longitude": "-80.2216949",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-724-0567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL1qtnloE2YgRtH-5TxQt82Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_a7c93e0a4a4f9443a26c9c58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward College - North Campus",
      "poi_type": "Education",
      "poi_address": "1000 Coconut Creek Blvd, Coconut Creek, FL 33066, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f7-167e-7697-87e8-ac36a1a66102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-167e-7697-87e8-ac36a1a66102",
        "storage_key": "property/5745554927648768/019f14f7-167e-7697-87e8-ac36a1a66102.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474434239044893085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-college---north-campus",
      "poi_latitude": "26.2405037",
      "poi_longitude": "-80.1737849",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-201-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafn_024D2YgRnbmhv4zO_ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b6179eb02637cde2a8031076",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Museum of Discovery and Science",
      "poi_type": "Entertainment",
      "poi_address": "401 SW 2nd St, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Downtown facility offering interactive exhibits for kids & adults, eco-center & giant IMAX theater.",
      "poi_long_description": "Downtown facility offering interactive exhibits for kids & adults, eco-center & giant IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2191-7412-ae48-b4ede21bcdcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2191-7412-ae48-b4ede21bcdcb",
        "storage_key": "property/5745554927648768/019f14f9-2191-7412-ae48-b4ede21bcdcb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3792408130309737923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery-and-science",
      "poi_latitude": "26.1206046",
      "poi_longitude": "-80.1479671",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 954-467-6637",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e538-736e-b630-1e7ffff31dfa",
        "storage_key": "property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2f1pZPkA2YgRw01q-hlXoTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_0f45a75056cfa993b2db4889",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "201 SW 5th Ave, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "Renovated theater hosting musicals, comedies, speakers & more, with luxe new Club Level lounge.",
      "poi_long_description": "Renovated theater hosting musicals, comedies, speakers & more, with luxe new Club Level lounge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-30b8-7509-8b3e-a75bcc194285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-30b8-7509-8b3e-a75bcc194285",
        "storage_key": "property/5745554927648768/019f14f9-30b8-7509-8b3e-a75bcc194285.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.browardcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2531387348230524317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-center-for-the-performing-arts",
      "poi_latitude": "26.1197559",
      "poi_longitude": "-80.14957729999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 954-462-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs8G0zPsA2YgRnc0yoGFLISM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_63770005bb3cf2d68a06f20a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "NSU Art Museum Fort Lauderdale",
      "poi_type": "Entertainment",
      "poi_address": "1 E Las Olas Blvd, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "Complex with more than 6,000 works of art, plus an academy, bookstore & cafe.",
      "poi_long_description": "Complex with more than 6,000 works of art, plus an academy, bookstore & cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-250b-75d9-9241-2ba44ea660af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-250b-75d9-9241-2ba44ea660af",
        "storage_key": "property/5745554927648768/019f14f9-250b-75d9-9241-2ba44ea660af.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://nsuartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10636868273401707191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nsu-art-museum-fort-lauderdale",
      "poi_latitude": "26.1196496",
      "poi_longitude": "-80.14276869999999",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 954-525-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e538-736e-b630-1e7ffff31dfa",
        "storage_key": "property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJdR_OXS4A2YgRtzq7jla_nZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_06fa680ce607bc2721c53382",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Bonnet House Museum & Gardens",
      "poi_type": "Entertainment",
      "poi_address": "900 N Birch Rd, Fort Lauderdale, FL 33304, USA",
      "poi_short_description": "Verdant, storied, 1920s-era plantation home featuring gardens, an arty interior, tours & more.",
      "poi_long_description": "Verdant, storied, 1920s-era plantation home featuring gardens, an arty interior, tours & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2b3e-760b-89cb-48934750711e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2b3e-760b-89cb-48934750711e",
        "storage_key": "property/5745554927648768/019f14f9-2b3e-760b-89cb-48934750711e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bonnethouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10089391772052130854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonnet-house-museum--gardens",
      "poi_latitude": "26.1363719",
      "poi_longitude": "-80.1069179",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 954-563-5393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e538-736e-b630-1e7ffff31dfa",
        "storage_key": "property/5745554927648768/019d02f3-e538-736e-b630-1e7ffff31dfa.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzaIz9AB2YgRJozqXFy4BIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_b02c7a15a9c5b5accbff269f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Xtreme Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5300 Powerline Rd, Fort Lauderdale, FL 33309, USA",
      "poi_short_description": "Complex with a half-mile asphalt go-kart track, bowling lanes, an indoor ropes course & a bar.",
      "poi_long_description": "Complex with a half-mile asphalt go-kart track, bowling lanes, an indoor ropes course & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-22aa-75cb-bd1e-b1e9d3335654.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-22aa-75cb-bd1e-b1e9d3335654",
        "storage_key": "property/5745554927648768/019f14f9-22aa-75cb-bd1e-b1e9d3335654.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://xtremeactionpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14883603637275764570&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xtreme-action-park",
      "poi_latitude": "26.1915924",
      "poi_longitude": "-80.1536955",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-491-6265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdEC7MUD2YgRWqeIwaYujc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_9aa29ac0ac92f777a280ae6b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale Swap Shop",
      "poi_type": "Entertainment",
      "poi_address": "3291 W Sunrise Blvd, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "Sprawling 1960s facility with a flea market, a Ferrari museum & a 14-screen drive-in movie theater.",
      "poi_long_description": "Sprawling 1960s facility with a flea market, a Ferrari museum & a 14-screen drive-in movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2687-7090-ab63-e8490eb7372a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2687-7090-ab63-e8490eb7372a",
        "storage_key": "property/5745554927648768/019f14f9-2687-7090-ab63-e8490eb7372a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://floridaswapshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2934117349858609916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-swap-shop",
      "poi_latitude": "26.1370252",
      "poi_longitude": "-80.1910838",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 954-791-7927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df98-7550-ae2e-17fe42f15b07",
        "storage_key": "property/5745554927648768/019d02f3-df98-7550-ae2e-17fe42f15b07.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJazjmCdQG2YgR_AqiHy8UuCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "flea_market"
    },
    {
      "id": "ec_a650d94f402f39b36e6637d7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "The Wharf Fort Lauderdale",
      "poi_type": "Entertainment",
      "poi_address": "20 W Las Olas Blvd, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "Open-air hangout, featuring food trucks, bars, live music, a dance floor, a deck and river views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-248a-7562-b428-14c23da917c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-248a-7562-b428-14c23da917c2",
        "storage_key": "property/5745554927648768/019f14f9-248a-7562-b428-14c23da917c2.webp",
        "width": 675,
        "height": 379
      },
      "poi_business_url": "https://wharfftl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1652192600425360310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wharf-fort-lauderdale",
      "poi_latitude": "26.1191782",
      "poi_longitude": "-80.1442069",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 954-372-7606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d8-73ed-9f2d-0ca15a664423.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d8-73ed-9f2d-0ca15a664423",
        "storage_key": "property/5745554927648768/019f14f9-73d8-73ed-9f2d-0ca15a664423.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzRAfooB2YgRtuvhmGrE7RY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_8fe7b2df602b8b950d0c851b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Hard Rock Live (in Seminole Hard Rock Hollywood)",
      "poi_type": "Entertainment",
      "poi_address": "1 Seminole Way, Davie, FL 33314, USA",
      "poi_short_description": "Relaxed, clean venue for comedy acts and musical performances, plus restaurants and bars with memorabilia.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-26df-70fa-b23a-5e9fba6d132c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-26df-70fa-b23a-5e9fba6d132c",
        "storage_key": "property/5745554927648768/019f14f9-26df-70fa-b23a-5e9fba6d132c.webp",
        "width": 746,
        "height": 460
      },
      "poi_business_url": "https://www.seminolehardrockhollywood.com/entertainment/hard-rock-live",
      "poi_directions_map_url": "https://maps.google.com/?cid=18443350764377183803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hard-rock-live-in-seminole-hard-rock-hollywood",
      "poi_latitude": "26.0534476",
      "poi_longitude": "-80.2112935",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 18 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 954-797-5531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ9RZ4Kp2YgRO5ahms3x8_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_6822976bc3311dd6580efb79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "The Parker",
      "poi_type": "Entertainment",
      "poi_address": "707 NE 8th St, Fort Lauderdale, FL 33304, USA",
      "poi_short_description": "Since 1967, this 1,167-seat theater has hosted Broadway plays, live music, dance, comedy & more.",
      "poi_long_description": "Since 1967, this 1,167-seat theater has hosted Broadway plays, live music, dance, comedy & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2ba5-7648-ae1f-b694a4b3d31f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2ba5-7648-ae1f-b694a4b3d31f",
        "storage_key": "property/5745554927648768/019f14f9-2ba5-7648-ae1f-b694a4b3d31f.webp",
        "width": 719,
        "height": 632
      },
      "poi_business_url": "http://parkerplayhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2557896587494693529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-parker",
      "poi_latitude": "26.134333",
      "poi_longitude": "-80.1362059",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 954-462-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmY1Oo64B2YgRmRrO3WR5fyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_9a4d5ae9ef20a41028ed720e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Regal Broward",
      "poi_type": "Entertainment",
      "poi_address": "8000 W Broward Blvd #1840, Plantation, FL 33388, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-3175-766b-9a6f-e922e9143e5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-3175-766b-9a6f-e922e9143e5e",
        "storage_key": "property/5745554927648768/019f14f9-3175-766b-9a6f-e922e9143e5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-broward-rpx-1762?utm_campaign=gmb-listing&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=7463737642510168395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-broward",
      "poi_latitude": "26.1161844",
      "poi_longitude": "-80.2539123",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d6-75e9-9911-47c87e26c82d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d6-75e9-9911-47c87e26c82d",
        "storage_key": "property/5745554927648768/019f14f9-73d6-75e9-9911-47c87e26c82d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJLSZkY8cH2YgRS7GHXteFlGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6a982079c9183b2b51fe9395",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Health North",
      "poi_type": "Health and Wellness",
      "poi_address": "201 E Sample Rd, Pompano Beach, FL 33064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2dea-71cc-ad2a-b65ee4015101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2dea-71cc-ad2a-b65ee4015101",
        "storage_key": "property/5745554927648768/019f14f9-2dea-71cc-ad2a-b65ee4015101.webp",
        "width": 1000,
        "height": 647
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-north?utm_source=gmb&utm_medium=organic&utm_campaign=location_page",
      "poi_directions_map_url": "https://maps.google.com/?cid=157741883867854105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-north",
      "poi_latitude": "26.2767648",
      "poi_longitude": "-80.12154919999999",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 954-941-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e817-7179-8a8c-17655b067281",
        "storage_key": "property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcDHwzcd2YgRGfUkWmhpMAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_8d43031b0b7e2f73f8d39dc4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1600 S Andrews Ave, Fort Lauderdale, FL 33316, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-3001-720c-800e-5d074acdf072.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-3001-720c-800e-5d074acdf072",
        "storage_key": "property/5745554927648768/019f14f9-3001-720c-800e-5d074acdf072.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-medical-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13938975603465299802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-medical-center",
      "poi_latitude": "26.1020681",
      "poi_longitude": "-80.1408664",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 954-355-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e817-7179-8a8c-17655b067281",
        "storage_key": "property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUw_UmAA2YgRWqdioXUwccE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_9a5853ca408cf1ef6b188e05",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "CareSpot Urgent Care of Tamarac",
      "poi_type": "Health and Wellness",
      "poi_address": "10251 W Commercial Blvd, Tamarac, FL 33351, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-3f8d-7411-967d-4260ab8106f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-3f8d-7411-967d-4260ab8106f1",
        "storage_key": "property/5745554927648768/019f14f9-3f8d-7411-967d-4260ab8106f1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.carespot.com/carespot-urgent-care/tamarac-fl/?utm_source=google&utm_medium=organic&utm_content=tamarac&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1275086464035222859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carespot-urgent-care-of-tamarac",
      "poi_latitude": "26.1943261",
      "poi_longitude": "-80.2870181",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-580-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09nMNVAP2YgRS3W6ImIEshE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_cf6759201a654683c9830231",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Chen Senior Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6037 Kimberly Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-34f9-77da-82a8-2de3885ab2ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-34f9-77da-82a8-2de3885ab2ce",
        "storage_key": "property/5745554927648768/019f14f9-34f9-77da-82a8-2de3885ab2ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chenmedicalcenters.com/find-a-location/broward-county/north-lauderdale/?y_source=1_Mzk0OTU1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4350118115228006705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chen-senior-medical-center",
      "poi_latitude": "26.2164512",
      "poi_longitude": "-80.2057926",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 954-379-8994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yfvP2YE2YgRMTkovWC5Xjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_61db198da259fba8fa95c4c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8790 W McNab Rd, Tamarac, FL 33321, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-4054-71ef-ad21-46c96f3c313c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-4054-71ef-ad21-46c96f3c313c",
        "storage_key": "property/5745554927648768/019f14f9-4054-71ef-ad21-46c96f3c313c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8790+w+mcnab+rd-tamarac-fl-33321/id=4484",
      "poi_directions_map_url": "https://maps.google.com/?cid=7373607787893547686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "26.207675",
      "poi_longitude": "-80.26771459999999",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-726-6008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa7I-JI0F2YgRpuJyTjdRVGY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_bec9a6bc92e86ea7cf2558c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7900 W McNab Rd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-35ba-75f8-b1ba-106d84a8bfa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-35ba-75f8-b1ba-106d84a8bfa9",
        "storage_key": "property/5745554927648768/019f14f9-35ba-75f8-b1ba-106d84a8bfa9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/1851-north-lauderdale-fl/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3553792780719121903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "26.2052519",
      "poi_longitude": "-80.2297667",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-726-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d3-76cc-b4e3-d5a9cfd0daba",
        "storage_key": "property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbPL80gE2YgR72UcjLSbUTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_cfa9669c9d9aadaab0335dec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6900 N University Dr, Tamarac, FL 33321, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-0994-718e-8a83-e79e1a6e0a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-0994-718e-8a83-e79e1a6e0a46",
        "storage_key": "property/5745554927648768/019f14f9-0994-718e-8a83-e79e1a6e0a46.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tamarac-fl-pharmacies/6900-n-university-dr-tamarac-fl-33321/storeid=5919?WT.mc_id=LS_GOOGLE_RX_5919",
      "poi_directions_map_url": "https://maps.google.com/?cid=393840869115570964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "26.2078276",
      "poi_longitude": "-80.25169009999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 954-724-1808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73d3-76cc-b4e3-d5a9cfd0daba",
        "storage_key": "property/5745554927648768/019f14f9-73d3-76cc-b4e3-d5a9cfd0daba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6Ccp78F2YgRFCuqDS80dwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_b497fb5c66beac3c2745daf7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Crunch Fitness - Tamarac",
      "poi_type": "Health and Wellness",
      "poi_address": "4017 W Commercial Blvd, Tamarac, FL 33319, USA",
      "poi_short_description": "Chain gym featuring a pool and a sauna, plus group fitness classes and personal trainers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f7-1fd6-74ed-afcb-a147d1a58fb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-1fd6-74ed-afcb-a147d1a58fb6",
        "storage_key": "property/5745554927648768/019f14f7-1fd6-74ed-afcb-a147d1a58fb6.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/tamarac",
      "poi_directions_map_url": "https://maps.google.com/?cid=4127582554189489142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---tamarac",
      "poi_latitude": "26.1881426",
      "poi_longitude": "-80.2045601",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 754-336-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2bdZwgF2YgR9mOQ03YeSDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ec913e598de83be85ce0afb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5470 W Sample Rd, Margate, FL 33073, USA",
      "poi_short_description": "Spotless fitness center offering treadmills and elliptical machines along with classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-3cc3-76f6-840b-6cc9535e0b2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-3cc3-76f6-840b-6cc9535e0b2a",
        "storage_key": "property/5745554927648768/019f14f9-3cc3-76f6-840b-6cc9535e0b2a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/margate-fl?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17826971367398210812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "26.2720259",
      "poi_longitude": "-80.197701",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 954-289-3999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8XpATK0E2YgR_HzU3gEgZvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ff1b88430b3ccc4ad264a3c9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Bombay Room Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "3354 NE 33rd St, Fort Lauderdale, FL 33308, USA",
      "poi_short_description": "Chic and welcoming studio for yoga classes and mediation courses for all levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-430e-7479-ae58-6ef4dff0764b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-430e-7479-ae58-6ef4dff0764b",
        "storage_key": "property/5745554927648768/019f14f9-430e-7479-ae58-6ef4dff0764b.webp",
        "width": 662,
        "height": 994
      },
      "poi_business_url": "http://www.bombayroomyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15122929070530564589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bombay-room-yoga",
      "poi_latitude": "26.1689824",
      "poi_longitude": "-80.10094169999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 954-567-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnSy_qv8B2YgR7RFnbN1v39E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_1eb08dec0bea0143c172cb76",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Hampton Pines Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7800 Hampton Blvd, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Wooded, local park featuring a playground & picnic area, plus a lake for fishing & paddle boating.",
      "poi_long_description": "Wooded, local park featuring a playground & picnic area, plus a lake for fishing & paddle boating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-4765-709e-9117-246ce79dae5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-4765-709e-9117-246ce79dae5f",
        "storage_key": "property/5745554927648768/019f14f9-4765-709e-9117-246ce79dae5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15091838799047308547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-pines-park",
      "poi_latitude": "26.2090177",
      "poi_longitude": "-80.2331234",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 954-724-7061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWlgo7QF2YgRAzWsgG37cNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f9cfdd579468dff82f0a289f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Woodville Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1500 SW 83rd Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Recreational venue offering separate areas for large and small dogs to roam and play, plus a restroom, and a kids' playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-4af1-727d-819e-3d15f08e9af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-4af1-727d-819e-3d15f08e9af1",
        "storage_key": "property/5745554927648768/019f14f9-4af1-727d-819e-3d15f08e9af1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11540230619587942380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodville-dog-park",
      "poi_latitude": "26.2076588",
      "poi_longitude": "-80.2392761",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4z8X7YF2YgR7BegEpsiJ6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_21dbc70d84f7a09fce270bcf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "SW 11th St, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14757074807198076373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "26.2155791",
      "poi_longitude": "-80.2375335",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVHLIF2YgR1U3ozlmpy8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7af632f21cb6eed0cd58b6e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Jerry Resnick Aquatic Center-Closed for the Season",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 SW 71st Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "Public pool offering swimming classes and a splash pad.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-47c8-7708-b0c8-1ebd69f12466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-47c8-7708-b0c8-1ebd69f12466",
        "storage_key": "property/5745554927648768/019f14f9-47c8-7708-b0c8-1ebd69f12466.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jeffellismanagement.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4835014369868365970&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jerry-resnick-aquatic-center-closed-for-the-season",
      "poi_latitude": "26.222017",
      "poi_longitude": "-80.2222477",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-724-7063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XxGRVcE2YgRksDpz_NrGUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "ec_9bda721a826d40ffd92b6039",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Gary B Jones Park for People and Pups",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8101 Southgate Blvd, Tamarac, FL 33321, USA",
      "poi_short_description": "Well-maintained park offering off-leash areas for large and small dogs, plus water fountains.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-494a-7615-a3b3-792b352dff5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-494a-7615-a3b3-792b352dff5c",
        "storage_key": "property/5745554927648768/019f14f9-494a-7615-a3b3-792b352dff5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tamarac.org/facilities.aspx?search=1&CID=2&RID=3&Page=detail",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584314634391246354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gary-b-jones-park-for-people-and-pups",
      "poi_latitude": "26.2293368",
      "poi_longitude": "-80.2559558",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 954-597-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDxPO_p8F2YgREtbnsJJ4f00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_18a7f01d87e36f9296bd951f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Mainlands Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4500 Monterey Dr, Tamarac, FL 33319, USA",
      "poi_short_description": "City park with picnic tables, water fountains, and golf opportunities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-4c71-7194-8f4c-cd86ddc112fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-4c71-7194-8f4c-cd86ddc112fd",
        "storage_key": "property/5745554927648768/019f14f9-4c71-7194-8f4c-cd86ddc112fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tamarac.org/Facilities/Facility/Details/Mainlands-Park-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=15302476507559211779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mainlands-park",
      "poi_latitude": "26.180957",
      "poi_longitude": "-80.2149139",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 954-597-3620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH53YbwwF2YgRA7PTwE5RXdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_2149147c9bfadabc93a9ec54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Tradewinds Park & Stables",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3600 W Sample Rd, Coconut Creek, FL 33066, USA",
      "poi_short_description": "Park featuring a disc golf course, fishing lake, kiddie train rides, stables & a butterfly farm.",
      "poi_long_description": "Park featuring a disc golf course, fishing lake, kiddie train rides, stables & a butterfly farm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-4e6c-7395-bac1-ccbaad7347da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-4e6c-7395-bac1-ccbaad7347da",
        "storage_key": "property/5745554927648768/019f14f9-4e6c-7395-bac1-ccbaad7347da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.org/parks/Pages/Park.aspx?=39",
      "poi_directions_map_url": "https://maps.google.com/?cid=17980233473364974666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tradewinds-park--stables",
      "poi_latitude": "26.280819",
      "poi_longitude": "-80.1724732",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 954-357-8870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKQurmrAc2YgRStyBphSfhvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2ffa5d13414560f109154568",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Markham Park & Target Range",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16001 FL-84, Sunrise, FL 33326, USA",
      "poi_short_description": "666-acre park featuring 11 miles of bike trails plus a model airplane field & lakes for jet skiing.",
      "poi_long_description": "666-acre park featuring 11 miles of bike trails plus a model airplane field & lakes for jet skiing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5343-716d-89be-1093deb4da19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5343-716d-89be-1093deb4da19",
        "storage_key": "property/5745554927648768/019f14f9-5343-716d-89be-1093deb4da19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.broward.org/Parks/Pages/park.aspx?park=23",
      "poi_directions_map_url": "https://maps.google.com/?cid=4258244424734907880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "markham-park--target-range",
      "poi_latitude": "26.1335114",
      "poi_longitude": "-80.3521085",
      "poi_miles_from_property": "17.8 mi",
      "poi_walking_minutes": "6 hours 35 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 954-357-8868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQtU14gJ2YgR6J0cP75SGDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7907dbbf2827bc3432839e5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Snyder Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3299 SW 4th Ave, Fort Lauderdale, FL 33315, USA",
      "poi_short_description": "Dogs swim & play in this recreation area with picnic & sporting areas for two-legged animals too.",
      "poi_long_description": "Dogs swim & play in this recreation area with picnic & sporting areas for two-legged animals too.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5a20-74c6-bfc6-bb0e3fcc260c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5a20-74c6-bfc6-bb0e3fcc260c",
        "storage_key": "property/5745554927648768/019f14f9-5a20-74c6-bfc6-bb0e3fcc260c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parks.fortlauderdale.gov/Home/Components/FacilityDirectory/FacilityDirectory/62/1091",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901779015313710797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snyder-park",
      "poi_latitude": "26.082714",
      "poi_longitude": "-80.148185",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 954-828-4585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc5Xp9oEA2YgRzd5oJSbCqG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c56a68fa3342c33c18270e66",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale Dog Beach",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1269 N Fort Lauderdale Beach Blvd, Fort Lauderdale, FL 33304, USA",
      "poi_short_description": "Popular with dog owners, this 100-yard stretch of sandy beach offers scenic views.",
      "poi_long_description": "Popular with dog owners, this 100-yard stretch of sandy beach offers scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5697-732e-af23-58665eb1d941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5697-732e-af23-58665eb1d941",
        "storage_key": "property/5745554927648768/019f14f9-5697-732e-af23-58665eb1d941.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.parks.fortlauderdale.gov/parks/dog-friendly-places",
      "poi_directions_map_url": "https://maps.google.com/?cid=13859355894294895151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-dog-beach",
      "poi_latitude": "26.1402841",
      "poi_longitude": "-80.1023879",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 954-828-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ea0c-717f-ae72-bdaff6390e7c",
        "storage_key": "property/5745554927648768/019d02f3-ea0c-717f-ae72-bdaff6390e7c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0qalNkB2YgRL9opf8FSVsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_0911653a19573a72b1a79bc8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Cypress Creek",
      "poi_type": "Transportation & Transit",
      "poi_address": "5910 NW 9th Avenue, Fort Lauderdale, FL 33309, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f7-3302-748f-a44a-c676931f435c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-3302-748f-a44a-c676931f435c",
        "storage_key": "property/5745554927648768/019f14f7-3302-748f-a44a-c676931f435c.webp",
        "width": 1280,
        "height": 849
      },
      "poi_business_url": "http://www.tri-rail.com/stations/cypress-creek-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16049071252587968703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-creek",
      "poi_latitude": "26.2011948",
      "poi_longitude": "-80.15036769999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ec5b-70d9-b0b0-ed9b2722990b",
        "storage_key": "property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVP-WrYD2YgRv3hwyUXBud4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_8e1a7e88607928fb8e35152d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Ft. Lauderdale Tri-Rail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 SW 21st Terrace, Fort Lauderdale, FL 33312, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-58f8-7624-b81b-d2ebe9a86e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-58f8-7624-b81b-d2ebe9a86e18",
        "storage_key": "property/5745554927648768/019f14f9-58f8-7624-b81b-d2ebe9a86e18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1560660171609454741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ft-lauderdale-tri-rail-station",
      "poi_latitude": "26.1194041",
      "poi_longitude": "-80.1699807",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 305-468-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73ea-722f-98ea-2579a840d949.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73ea-722f-98ea-2579a840d949",
        "storage_key": "property/5745554927648768/019f14f9-73ea-722f-98ea-2579a840d949.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJST1KeNsA2YgRlbjhRyiUqBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_6b2464c554a010868d59796d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale-Hollywood International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Terminal Dr, Fort Lauderdale, FL 33315, USA",
      "poi_short_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_long_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5c12-77e6-9b05-d34e43589166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5c12-77e6-9b05-d34e43589166",
        "storage_key": "property/5745554927648768/019f14f9-5c12-77e6-9b05-d34e43589166.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/airport/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3089526096205892582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-hollywood-international-airport",
      "poi_latitude": "26.0731729",
      "poi_longitude": "-80.1512317",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 866-435-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-eb40-763f-b3f3-15f207dea039.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-eb40-763f-b3f3-15f207dea039",
        "storage_key": "property/5745554927648768/019d02f3-eb40-763f-b3f3-15f207dea039.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9frI5Hqq2YgR5sumkJ0z4Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_973963f34d34e6bd3d4ea171",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 Gulf Stream Way, Dania Beach, FL 33004, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5cd1-716e-8da3-8e645354b645.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5cd1-716e-8da3-8e645354b645",
        "storage_key": "property/5745554927648768/019f14f9-5cd1-716e-8da3-8e645354b645.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tri-rail.com/stations/fort-lauderdalehollywood-international-airport-at-dania-beach/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1078809497329506260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-airport",
      "poi_latitude": "26.0616447",
      "poi_longitude": "-80.16561879999999",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ec5b-70d9-b0b0-ed9b2722990b",
        "storage_key": "property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJx53JMRWq2YgR1JekpIWz-A4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_91ad9499ef2816f64ebe9935",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Tri-Rail Pompano Beach Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pompano Beach Station, 3301 NW 8th Ave, Pompano Beach, FL 33064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5c6d-746f-9697-d1cd393ea5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5c6d-746f-9697-d1cd393ea5f6",
        "storage_key": "property/5745554927648768/019f14f9-5c6d-746f-9697-d1cd393ea5f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tri-rail.com/stations/pompano-beach",
      "poi_directions_map_url": "https://maps.google.com/?cid=1516474553600478517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tri-rail-pompano-beach-station",
      "poi_latitude": "26.271884",
      "poi_longitude": "-80.13399369999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-874-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX3Tpdi4d2YgRNY1GZpKZCxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_618cc440622efa57d43b36c8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 NW 2nd Ave, Fort Lauderdale, FL 33311, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-62bc-763f-8231-b71316cdb4f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-62bc-763f-8231-b71316cdb4f2",
        "storage_key": "property/5745554927648768/019f14f9-62bc-763f-8231-b71316cdb4f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gobrightline.com/fort-lauderdale",
      "poi_directions_map_url": "https://maps.google.com/?cid=3758530637296426461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale",
      "poi_latitude": "26.1235832",
      "poi_longitude": "-80.1460689",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-ec5b-70d9-b0b0-ed9b2722990b",
        "storage_key": "property/5745554927648768/019d02f3-ec5b-70d9-b0b0-ed9b2722990b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-OfwnsB2YgR3d15ebP7KDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_44c55459652f39edcff12733",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward County Transit (Central Terminal)",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 NW 1st Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5cc9-704a-b635-9e821f3d487b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5cc9-704a-b635-9e821f3d487b",
        "storage_key": "property/5745554927648768/019f14f9-5cc9-704a-b635-9e821f3d487b.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://www.broward.org/BCT/Riders/Pages/JustTryIt.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=408228831615665290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-transit-central-terminal",
      "poi_latitude": "26.1232797",
      "poi_longitude": "-80.145039",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 954-357-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52vyvv8B2YgRikSGn_VRqgU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_752ddf7bcd47f964306dd1df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Lauderhill Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lauderhill, FL 33313, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-63d6-7661-8cc9-54be61e9f7ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-63d6-7661-8cc9-54be61e9f7ca",
        "storage_key": "property/5745554927648768/019f14f9-63d6-7661-8cc9-54be61e9f7ca.webp",
        "width": 1280,
        "height": 838
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3410592391200418352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lauderhill-transit-center",
      "poi_latitude": "26.143282",
      "poi_longitude": "-80.203125",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUzsSNsG2YgRMKomr7XbVC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_f4a64a09f96dcaa05eba5f9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Northeast Transit Center - (Martin Luther King Boulevard & Dixie Hwy)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Pompano Beach, FL 33060, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-62b4-732a-a5f7-8ecab9eb996e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-62b4-732a-a5f7-8ecab9eb996e",
        "storage_key": "property/5745554927648768/019f14f9-62b4-732a-a5f7-8ecab9eb996e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7635286017308890433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-transit-center---martin-luther-king-boulevard--dixie-hwy",
      "poi_latitude": "26.234051",
      "poi_longitude": "-80.1259",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e4de-7628-90f0-e14b46229706",
        "storage_key": "property/5745554927648768/019d02f3-e4de-7628-90f0-e14b46229706.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6D62-0C2YgRQRU05C389Wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_ab47282acd5193c604634ccb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward County Sheriff's Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 SW 71st Ave, North Lauderdale, FL 33068, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sheriff.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3763171704761973046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-sheriffs-office",
      "poi_latitude": "26.222042",
      "poi_longitude": "-80.2212935",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 954-722-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73f3-708b-bed0-60dcc0909ef2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73f3-708b-bed0-60dcc0909ef2",
        "storage_key": "property/5745554927648768/019f14f9-73f3-708b-bed0-60dcc0909ef2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XxGRVcE2YgRNnkjM7p4OTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_953be9b6fc1bb9405da910d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward College - North Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Coconut Creek Blvd, Coconut Creek, FL 33066, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f7-167e-7697-87e8-ac36a1a66102.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f7-167e-7697-87e8-ac36a1a66102",
        "storage_key": "property/5745554927648768/019f14f7-167e-7697-87e8-ac36a1a66102.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474434239044893085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-college---north-campus",
      "poi_latitude": "26.2405037",
      "poi_longitude": "-80.1737849",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 954-201-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafn_024D2YgRnbmhv4zO_ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_9b0884af087905b9ceb434a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Health Coral Springs",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 Coral Hills Dr, Coral Springs, FL 33065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-6691-709b-af8a-29b740cee17f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-6691-709b-af8a-29b740cee17f",
        "storage_key": "property/5745554927648768/019f14f9-6691-709b-af8a-29b740cee17f.webp",
        "width": 1100,
        "height": 825
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-coral-springs?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=3563055375264312311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-coral-springs",
      "poi_latitude": "26.2687399",
      "poi_longitude": "-80.25565639999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 954-344-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e817-7179-8a8c-17655b067281",
        "storage_key": "property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp9sWx0kF2YgR9-usZfyDcjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_8cbee554e42f0d1a67591eba",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Health North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 E Sample Rd, Pompano Beach, FL 33064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-2dea-71cc-ad2a-b65ee4015101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-2dea-71cc-ad2a-b65ee4015101",
        "storage_key": "property/5745554927648768/019f14f9-2dea-71cc-ad2a-b65ee4015101.webp",
        "width": 1000,
        "height": 647
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-north?utm_source=gmb&utm_medium=organic&utm_campaign=location_page",
      "poi_directions_map_url": "https://maps.google.com/?cid=157741883867854105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-north",
      "poi_latitude": "26.2767648",
      "poi_longitude": "-80.12154919999999",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 954-941-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e817-7179-8a8c-17655b067281",
        "storage_key": "property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkcDHwzcd2YgRGfUkWmhpMAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_eb74f2772acabfc17f779518",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Nova Southeastern University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3300 S University Dr, Fort Lauderdale, FL 33328, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-66fe-762c-90fa-68b19fd30eda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-66fe-762c-90fa-68b19fd30eda",
        "storage_key": "property/5745554927648768/019f14f9-66fe-762c-90fa-68b19fd30eda.webp",
        "width": 1280,
        "height": 951
      },
      "poi_business_url": "http://www.nova.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12169842592624840886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nova-southeastern-university",
      "poi_latitude": "26.0791417",
      "poi_longitude": "-80.2465466",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 49 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 800-541-6682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP64CCSWo2YgRtpDSAVz346g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b3dd4101e69ed7423dd50299",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Florida Atlantic University - Davie Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3200 College Ave, Davie, FL 33314, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-6964-70eb-a4af-33af39043e5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-6964-70eb-a4af-33af39043e5c",
        "storage_key": "property/5745554927648768/019f14f9-6964-70eb-a4af-33af39043e5c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.fau.edu/about/davie.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=1599825648170032817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "florida-atlantic-university---davie-campus",
      "poi_latitude": "26.0825178",
      "poi_longitude": "-80.23569739999999",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 954-236-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRRc1dSyo2YgRsd67ZfO4MxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_13078dc0028df854bf0c0cc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward Health Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 S Andrews Ave, Fort Lauderdale, FL 33316, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-3001-720c-800e-5d074acdf072.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-3001-720c-800e-5d074acdf072",
        "storage_key": "property/5745554927648768/019f14f9-3001-720c-800e-5d074acdf072.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.browardhealth.org/locations/broward-health-medical-center?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13938975603465299802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-health-medical-center",
      "poi_latitude": "26.1020681",
      "poi_longitude": "-80.1408664",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 954-355-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-e817-7179-8a8c-17655b067281",
        "storage_key": "property/5745554927648768/019d02f3-e817-7179-8a8c-17655b067281.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUw_UmAA2YgRWqdioXUwccE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_0a7eb6b6ddd3127ffcff8295",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Fort Lauderdale-Hollywood International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Terminal Dr, Fort Lauderdale, FL 33315, USA",
      "poi_short_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_long_description": "Airport with free WiFi, a cell phone waiting lot & areas to observe planes taking off & landing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-5c12-77e6-9b05-d34e43589166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-5c12-77e6-9b05-d34e43589166",
        "storage_key": "property/5745554927648768/019f14f9-5c12-77e6-9b05-d34e43589166.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.broward.org/airport/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3089526096205892582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-lauderdale-hollywood-international-airport",
      "poi_latitude": "26.0731729",
      "poi_longitude": "-80.1512317",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 866-435-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-eb40-763f-b3f3-15f207dea039.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-eb40-763f-b3f3-15f207dea039",
        "storage_key": "property/5745554927648768/019d02f3-eb40-763f-b3f3-15f207dea039.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9frI5Hqq2YgR5sumkJ0z4Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_2c6f2dd4a81f1b4b0a095a80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward County Governmental Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "115 S Andrews Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-69c6-7485-9d56-d8a8db0ae532.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-69c6-7485-9d56-d8a8db0ae532",
        "storage_key": "property/5745554927648768/019f14f9-69c6-7485-9d56-d8a8db0ae532.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.broward.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10438013078851339141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-governmental-center",
      "poi_latitude": "26.1209754",
      "poi_longitude": "-80.1439666",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 954-831-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-73f3-708b-bed0-60dcc0909ef2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f9-73f3-708b-bed0-60dcc0909ef2",
        "storage_key": "property/5745554927648768/019f14f9-73f3-708b-bed0-60dcc0909ef2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbNMvfgA2YgRhcPQnZdF25A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_4f7f64702b8bdbf0f49a6889",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "generator",
      "poi_name": "Broward County Public Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 SE 3rd Ave, Fort Lauderdale, FL 33301, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14f9-68a9-72fd-a088-008fb3f4e344.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f9-68a9-72fd-a088-008fb3f4e344",
        "storage_key": "property/5745554927648768/019f14f9-68a9-72fd-a088-008fb3f4e344.webp",
        "width": 842,
        "height": 1280
      },
      "poi_business_url": "http://www.browardschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3294897416607880254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broward-county-public-schools",
      "poi_latitude": "26.1145382",
      "poi_longitude": "-80.1398808",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 754-321-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02f3-df6c-77d8-977e-ae0ea00e1bba",
        "storage_key": "property/5745554927648768/019d02f3-df6c-77d8-977e-ae0ea00e1bba.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL3_Ks9Kp2YgRPtRDSL7TuS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d916d3f5ca0d5027aa35e023",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3e1476faec4934d75379a5a3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_42023d96e60d7013827c43ab",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fdaf0db0e8b13754785cd069",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_95a8ec3e77d6397bce271d18",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_8c65b2fba3effc81aeeca11e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_a24068559da1f1b9741b4181",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "rating": "5",
      "name": "Dana Hagins",
      "text": "I had such a great experience moving into this apartment community! Claudia went above and beyond to help me throughout the entire process. Everything was smooth, stress-free, and handled with care. She is truly a wonderful person kind, patient, and genuinely caring. I’m so grateful for her support, she made this transition easy and enjoyable.\n\nI also want to thank the entire office staff and maintenance team also they are all so friendly, responsive, and helpful. It really makes a difference knowing you’re surrounded by such a great team.\nHighly recommend!",
      "date": "2026-06-16",
      "title": "false"
    },
    {
      "id": "ec_e7e3a1f184c85224c1e6e9ec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "rating": "5",
      "name": "Robert Espinales",
      "text": "I have really enjoyed living at The Asher Apartments. The property is well maintained, the grounds are kept clean, and the community feels safe and welcoming.\n\nOne of the biggest reasons for my positive experience has been Claudia. She is always professional, friendly, and willing to help whenever questions or concerns come up. Her communication is excellent, and she genuinely cares about the residents. It’s rare to find someone who consistently goes above and beyond to provide great customer service, but Claudia does exactly that.\n\nThe maintenance team is responsive, and the staff works hard to make sure residents are taken care of. Overall, I would recommend The Asher Apartments to anyone looking for a comfortable place to live with a team that truly values its residents.\n\nThank you, Claudia, for all your hard work and dedication!",
      "date": "2026-06-18",
      "title": "false"
    },
    {
      "id": "ec_2404d4f6414c2429baae42c5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "rating": "5",
      "name": "Naj",
      "text": "I've had a great experience living here, and I wanted to take a moment to recognize the leasing office and staff for all of their help.\n\nEveryone I've interacted with has been professional, friendly, and willing to help whenever I've had questions or needed assistance. Moving can be stressful, but the team made the process much smoother than I expected.\n\nI especially want to give a huge shout out to Claudia. From the very beginning, she has gone above and beyond to help with my move-in and various accommodations along the way. She's always been patient, responsive, and genuinely caring. No matter what issue came up, Claudia took the time to listen, find solutions, and make sure everything was handled properly. It's rare to find someone who consistently provides that level of customer service and attention to detail.\n\nHaving someone like Claudia on the team makes a real difference in the resident experience. Her professionalism, kindness, and willingness to help have not gone unnoticed, and I'm very grateful for everything she's done.\n\nThank you to the entire team for all of your hard work, and an extra thank you to Claudia for making my experience here such a positive one.",
      "date": "2026-06-15",
      "title": "false"
    },
    {
      "id": "ec_3be37b148bdcb408d208016d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "rating": "5",
      "name": "Wendy Olcima",
      "text": "Indhira is amazing! I truly love living here, and the entire office staff is always so attentive. Whether it’s a work order or a general concern, there is always a prompt response. The amenities are wonderful I especially love the gym and the pool and the view is absolutely breathtaking. I’ve been living here for five years now, and I couldn’t be happier. If you’re considering moving here, definitely reach out to Indhira.I guarantee that you won’t regret it. She is genuinely kind and provides outstanding customer service. I love it here.",
      "date": "2026-01-07",
      "title": "false"
    },
    {
      "id": "ec_159d287a92c9d2fe3376a34f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "rating": "5",
      "name": "Zoe Belle",
      "text": "Angie was great from start to finish! The tour was smooth, she explained everything so well, and made sure all of our concerns were answered. Definitely a 10/10 experience! Thank you Angie!",
      "date": "2026-01-30",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e0577323-d3c9-4d62-9fdc-ac1c62280301",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f4-2bd8-72a7-9c03-319ff8c8c654.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment community lounge area with seating, tables, and a bar.",
        "public_id": "019d02f4-2bd8-72a7-9c03-319ff8c8c654",
        "storage_key": "property/5745554927648768/019d02f4-2bd8-72a7-9c03-319ff8c8c654.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=USTRqKoJg13"
    },
    {
      "id": "custom_06e410bc-d1f8-4b53-8f72-e46f2e8df115",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f5-191f-77da-b428-49f40dcafc37.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with cardio machines and weight equipment",
        "public_id": "019d02f5-191f-77da-b428-49f40dcafc37",
        "storage_key": "property/5745554927648768/019d02f5-191f-77da-b428-49f40dcafc37.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kpDh3wJ4Hf7"
    },
    {
      "id": "custom_4a718c95-76d1-4573-81f5-c1710b5ba0d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019d02f4-3597-71c8-864a-1839c29e1e27.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas outside apartment buildings",
        "public_id": "019d02f4-3597-71c8-864a-1839c29e1e27",
        "storage_key": "property/5745554927648768/019d02f4-3597-71c8-864a-1839c29e1e27.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gnixJwHDiUF"
    },
    {
      "id": "custom_2431295b-ef01-4cba-a74b-29f26c71dd92",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f14c3-6a7e-7395-806a-d355e38c419f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-6a7e-7395-806a-d355e38c419f",
        "storage_key": "property/5745554927648768/019f14c3-6a7e-7395-806a-d355e38c419f.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Asher Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/cQnS3SBEncM"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-072e-7018-bc73-4bdce3db4cdc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-asher",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768"
    },
    {
      "lead_collector_id": "0198aa46-0792-70e1-b93b-2242c6ac7f4d",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-asher",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768"
    },
    {
      "lead_collector_id": "0198aa46-07f5-77fd-a7ac-6fed64433196",
      "lead_source": "LANDING_PAGE",
      "name": "the-asher",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "dog-park-apartments-north-lauderdale-fl-387",
      "search_query": "dog park apartments north lauderdale fl",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in North Lauderdale, FL",
      "h2_subtitle": "Discover dog-friendly living at The Asher. Our North Lauderdale apartments feature an onsite dog park perfect for your furry friends.",
      "page_copy": "Welcome to The Asher in North Lauderdale, FL, where pet-friendly living takes center stage with our fantastic onsite dog park. Our spacious one, two, and three-bedroom homes are designed not just for you, but for your furry companions as well. Step outside and let your pets enjoy the dedicated dog park, perfect for exercise and socializing. Life in North Lauderdale is vibrant and accommodating at The Asher.\n\nAlong with the pet amenities, our community offers a serene lake view, a sparkling pool, and convenient online resident services. Situated in Broward County, The Asher combines modern living with plenty of perks, including a BBQ area and car wash services. Discover why our dog park apartments are the ideal place for you and your pet to call home. Explore our availability or plan a visit today, and see all that we have to offer at The Asher!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments North Lauderdale, FL",
      "seo_description": "Find dog-friendly apartments with a dog park at The Asher in North Lauderdale, FL. Enjoy a pet-friendly lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "resort-style-pool-broward-county-946",
      "search_query": "resort style pool broward county",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool in Broward County",
      "h2_subtitle": "Experience luxury with a resort-style pool at The Asher in Broward County. Our community offers relaxation and vibrant living in North Lauderdale.",
      "page_copy": "Dive into luxury at The Asher, located in beautiful Broward County, FL, where our resort-style pool serves as a refreshing escape from the everyday. Nestled in North Lauderdale, our apartment community invites you to enjoy the serene lake views and a pool area that rivals any resort. Whether you're looking to unwind after a busy day or spend a sunny afternoon by the water, The Asher provides the perfect setting.\n\nOur one, two, and three-bedroom homes are designed with comfort and convenience in mind, offering a host of amenities such as BBQ areas and a dedicated car wash. Plus, with our online resident services, managing your home life is a breeze. Discover how our resort-style pool and other unique features create an unparalleled living experience in Broward County. Come explore The Asher today, and find your perfect apartment home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Broward County",
      "seo_description": "Enjoy a resort-style pool at The Asher in Broward County, FL. Discover luxury living in North Lauderdale with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "apartments-with-walk-in-closet-33068-400",
      "search_query": "apartments with walk in closet 33068",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets in 33068",
      "h2_subtitle": "Find spacious walk-in closets at The Asher, located in the 33068 area. Our North Lauderdale apartments offer convenience and style.",
      "page_copy": "At The Asher in North Lauderdale, FL, we understand the importance of space and comfort, which is why our apartments in the 33068 area feature expansive walk-in closets. Our one, two, and three-bedroom homes are designed to provide ample storage solutions, ensuring your belongings are well-organized and easily accessible. Enjoy modern living with all the comforts you'd expect in a superior apartment community.\n\nBeyond the spacious interiors, The Asher offers a wealth of amenities that enhance your lifestyle, including a resort-style pool, a serene lake view, and a convenient dog park. Located in the heart of Broward County, our community promises both relaxation and greater convenience with easy access to everything you need. Discover why walk-in closets at The Asher are just the beginning of a truly exceptional living experience. Schedule a tour or check out our availability today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closet 33068",
      "seo_description": "Explore apartments with walk-in closets at The Asher in the 33068 area. Enjoy spacious living in North Lauderdale with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-north-lauderdale-883",
      "search_query": "fitness center apartments near north lauderdale",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near North Lauderdale",
      "h2_subtitle": "Stay active and healthy at The Asher's apartments near North Lauderdale. Enjoy our well-equipped fitness center and exceptional amenities.",
      "page_copy": "Discover a thriving community lifestyle at The Asher, where our fitness center sets the tone for a healthy living experience near North Lauderdale. Our one, two, and three-bedroom homes provide the perfect blend of convenience and comfort, with access to a fully-equipped fitness center that caters to residents seeking an active lifestyle. Step into a vibrant community that prioritizes wellness along with relaxation.\n\nBeyond the excellent fitness facilities, The Asher offers a host of amenities including a serene lake view, a rejuvenating resort-style pool, and a dog park for your furry friends. Located in the heart of Broward County, our community ensures every aspect of modern living is covered. Whether you're looking to maintain your fitness routine or unwind by the pool, The Asher has it all. Explore availability and schedule a tour today, and begin living the lifestyle you deserve.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near North Lauderdale",
      "seo_description": "Find apartments with a fitness center near North Lauderdale at The Asher. Enjoy active living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "lake-view-apartments-north-lauderdale-198",
      "search_query": "lake view apartments north lauderdale",
      "category": "Amenity",
      "h1_title": "Lake View Apartments in North Lauderdale",
      "h2_subtitle": "Enjoy stunning lake views at The Asher in North Lauderdale. Our apartments offer scenic beauty and modern conveniences in Broward County.",
      "page_copy": "Embrace the serene beauty of lakeside living at The Asher, where our North Lauderdale apartments boast breathtaking lake views. Located in the heart of Broward County, our community offers a peaceful retreat with modern amenities and scenic surroundings. Whether you're sipping coffee on your balcony or enjoying a peaceful stroll around the community, the lake views provide a picturesque backdrop to your daily life.\n\nOur spacious one, two, and three-bedroom homes are complemented by a range of amenities designed for relaxation and enjoyment, including a resort-style pool, a BBQ area, and a convenient dog park. With our online resident services, managing your home has never been easier. Discover how life at The Asher combines stunning natural beauty with comfort and convenience, all while enjoying the best of North Lauderdale. Visit us today to experience it for yourself!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake View Apartments North Lauderdale",
      "seo_description": "Discover lake view apartments at The Asher in North Lauderdale. Enjoy scenic views and modern amenities in Broward County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-north-lauderdale-fl-208",
      "search_query": "one bedroom apartments North Lauderdale FL",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Lauderdale, FL",
      "h2_subtitle": "Discover your ideal one bedroom apartment at The Asher, North Lauderdale, FL. Enjoy modern living and exceptional amenities in a vibrant community.",
      "page_copy": "At The Asher in North Lauderdale, FL, our one bedroom apartments are designed with modern living in mind, offering a perfect balance of comfort and style. Located in the vibrant city of North Lauderdale, our community boasts spacious one-bedroom layouts that cater to diverse lifestyles. With contemporary finishes and thoughtful designs, our homes provide a serene retreat from the bustling city life.\n\nIn addition to well-appointed interiors, residents enjoy a wealth of amenities, including a refreshing pool, a BBQ area for entertaining, and a peaceful lake view. Our community is pet-friendly, featuring a convenient dog park, so all members of your household are welcome. Situated in Broward County, The Asher is more than just a place to live; it's a place to call home. Discover the convenience and beauty of our community today—schedule a tour of our one bedroom apartments!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments North Lauderdale, FL",
      "seo_description": "Find your perfect one bedroom apartment at The Asher, North Lauderdale, FL. Modern living with resort-style amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-broward-county-812",
      "search_query": "two bedroom apartments Broward County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broward County",
      "h2_subtitle": "Explore stylish two bedroom apartments at The Asher in Broward County. Enjoy modern amenities and a vibrant community lifestyle.",
      "page_copy": "Welcome to The Asher, where our two bedroom apartments in Broward County offer the perfect blend of style and comfort. Designed for those who seek spacious living spaces, our two-bedroom layouts provide a welcoming atmosphere with modern finishes. Whether you're accommodating a family or looking for additional space, our apartments are versatile and ideal for diverse lifestyles.\n\nLiving at The Asher means enjoying a host of exceptional amenities, including a serene lake view, a sparkling pool, and convenient online resident services. Our community is located in North Lauderdale, offering easy access to the vibrant cultural and recreational activities in Broward County. Embrace a lifestyle of convenience and relaxation, and experience the best of what The Asher has to offer. Schedule a tour today to see our two bedroom apartments firsthand!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Broward County",
      "seo_description": "Discover two bedroom apartments in Broward County at The Asher. Enjoy modern living and resort-style amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-33068-669",
      "search_query": "three bedroom apartments near 33068",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 33068",
      "h2_subtitle": "Find your spacious three bedroom apartment at The Asher, located conveniently near the 33068 area. Experience modern living with ample amenities.",
      "page_copy": "At The Asher, discover expansive three bedroom apartments that offer inviting and functional spaces, perfectly suited for families or individuals needing additional room. Located near the 33068 area in North Lauderdale, our community combines convenience and comfort with easy access to the vibrant heart of Broward County.\n\nEmbrace a life of leisure with amenities designed to elevate your living experience. Enjoy peaceful lake views, unwind by the resort-style pool, or socialize at the BBQ area. Pet owners will appreciate the dog park, ensuring even canine companions feel at home. Our three bedroom layouts provide the ideal setting for making memories, offering plenty of room to accommodate a variety of lifestyles. Visit The Asher today to explore how our community and homes can enhance your lifestyle near 33068.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 33068",
      "seo_description": "Discover three bedroom apartments near 33068 at The Asher. Enjoy spacious living with modern amenities in North Lauderdale.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "apartments-near-broward-college-north-campus-779",
      "search_query": "apartments near Broward College North Campus Lauderdale",
      "category": "School",
      "h1_title": "Apartments Near Broward College North Campus",
      "h2_subtitle": "Explore convenient apartments near Broward College North Campus at The Asher. Enjoy a relaxed lifestyle with easy access to education and amenities.",
      "page_copy": "The Asher offers ideal living solutions for students and faculty with its proximity to Broward College North Campus in Lauderdale. Our thoughtfully designed apartments provide a cozy refuge just minutes away from campus, making it easy to balance student life with a comfortable home environment. Each apartment boasts modern amenities and spacious interiors, perfect for both studying and relaxation.\n\nResidents of The Asher enjoy a variety of community features, including a refreshing pool, a serene lake view, and a BBQ area for social gatherings. Nestled in North Lauderdale, and conveniently accessible to Broward College, our location is perfect for those pursuing academic success while enjoying resort-style living. Experience the seamless blend of education and leisure at The Asher by scheduling a tour of our apartments near Broward College North Campus today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Broward College North Campus",
      "seo_description": "Find apartments near Broward College North Campus at The Asher. Enjoy convenient living with modern amenities close to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "apartments-close-to-keiser-university-fort-lauderdale-831",
      "search_query": "apartments close to Keiser University Fort Lauderdale FL",
      "category": "School",
      "h1_title": "Apartments Close to Keiser University FL",
      "h2_subtitle": "Discover convenient apartments close to Keiser University in Fort Lauderdale, FL, at The Asher. Perfect for students and faculty seeking modern living options.",
      "page_copy": "Located in the vibrant community of North Lauderdale, The Asher offers an ideal living experience for those studying or working at Keiser University in Fort Lauderdale, FL. Our stylish and contemporary apartments provide a comfortable retreat just a short drive from campus, allowing you to enjoy the convenience of a quick commute combined with a peaceful living environment.\n\nThe Asher's extensive amenities include a serene lake view, a sparkling pool, and a BBQ area, providing our residents with a resort-like lifestyle. Whether you're studying, working, or simply unwinding, you'll find the perfect balance here. With spacious one, two, and three bedroom options, The Asher caters to diverse needs, making it an excellent choice for students and professionals alike. Visit us to explore homes that meet both your educational and lifestyle needs near Keiser University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Keiser University FL",
      "seo_description": "Find apartments close to Keiser University in Fort Lauderdale at The Asher. Ideal for students and faculty looking for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "apartments-near-holy-cross-health-north-lauderdale-234",
      "search_query": "apartments near Holy Cross Health North Lauderdale",
      "category": "Hospital",
      "h1_title": "Apartments Near Holy Cross Health",
      "h2_subtitle": "Explore apartments near Holy Cross Health in North Lauderdale at The Asher. Experience easy access to wellness alongside modern living amenities.",
      "page_copy": "The Asher in North Lauderdale offers the perfect living solution for anyone working or seeking healthcare at Holy Cross Health. Located nearby, our apartments ensure a short commute, allowing you to maximize your time and energy efficiently. Residents enjoy a welcoming environment with access to modern, spacious homes that provide the perfect blend of comfort and convenience.\n\nWith lake views, a refreshing pool, and a dedicated BBQ area, The Asher provides a serene setting ideal for unwinding after a busy day. These features, paired with pet-friendly options like our dog park, create a community that feels like a true retreat. Whether you choose a one, two, or three-bedroom apartment, you'll find it’s easy to balance work and relaxation at The Asher, situated near Holy Cross Health in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holy Cross Health",
      "seo_description": "Find apartments near Holy Cross Health in North Lauderdale at The Asher. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "asher-close-to-hca-florida-northwest-hospital-188",
      "search_query": "The Asher close to HCA Florida Northwest Hospital Broward County",
      "category": "Hospital",
      "h1_title": "The Asher Near HCA Florida Northwest Hospital",
      "h2_subtitle": "Discover The Asher's proximity to HCA Florida Northwest Hospital in Broward County. Enjoy modern amenities within a short drive from essential healthcare services.",
      "page_copy": "Experience convenient living at The Asher, ideally situated near HCA Florida Northwest Hospital in Broward County. Our location is perfect for healthcare professionals and patients looking for nearby accommodations. With just a short drive separating you from essential medical services, you can easily balance a demanding schedule with a relaxing home environment.\n\nThe Asher offers a tranquil retreat with resort-style amenities like a sparkling pool, lake views, and a welcoming BBQ area, making it the ideal place to unwind. Choose from spacious one, two, or three-bedroom homes designed with comfort and modern convenience in mind. Our pet-friendly community also includes a dog park, ensuring every member of the family feels at home. Discover the ease of living close to HCA Florida Northwest Hospital at The Asher in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Asher Near HCA Florida Northwest Hospital",
      "seo_description": "Discover The Asher near HCA Florida Northwest Hospital in Broward. Enjoy convenient living with modern amenities close to healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "apartments-near-mills-pond-park-north-lauderdale-754",
      "search_query": "apartments near Mills Pond Park North Lauderdale",
      "category": "Park",
      "h1_title": "Apartments Near Mills Pond Park",
      "h2_subtitle": "Find beautiful apartments near Mills Pond Park in North Lauderdale. The Asher offers the perfect blend of nature and modern living.",
      "page_copy": "Nestled in North Lauderdale, The Asher provides residents with the ideal location close to Mills Pond Park, a popular outdoor sanctuary. Perfect for those who appreciate nature and leisure, our apartments allow you to enjoy the park's trails, sports facilities, and serene environment just moments from your doorstep.\n\nAt The Asher, you'll find spacious one, two, and three-bedroom homes designed with modern comfort and style. Our community amenities, including a refreshing pool, serene lake views, and a dedicated BBQ area, let you enjoy both relaxation and recreation. The pet-friendly community also includes a dog park, making it a perfect spot for animal lovers. Experience the best of city convenience and park-side tranquility at The Asher, near Mills Pond Park in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mills Pond Park",
      "seo_description": "Explore The Asher's apartments near Mills Pond Park in North Lauderdale. Enjoy modern living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "holiday-park-nearby-apartments-broward-county-296",
      "search_query": "holiday park nearby apartments in Broward County",
      "category": "Park",
      "h1_title": "Apartments Near Holiday Park Broward",
      "h2_subtitle": "Discover nearby apartments in Broward County close to Holiday Park. The Asher offers convenient living with modern amenities.",
      "page_copy": "Located in the heart of Broward County, The Asher provides residents with easy access to Holiday Park, a hub of outdoor activities and community events. Whether you're into sports, concerts, or leisurely strolls, living near Holiday Park offers endless entertainment options right outside your doorstep.\n\nThe Asher features spacious one, two, and three-bedroom apartments designed with you in mind. Residents enjoy luxurious amenities including a swimming pool, picturesque lake views, and a community BBQ area, perfect for gatherings with friends. Plus, with pet-friendly spaces including a dog park, The Asher makes everyone in the family feel welcome. Experience the perfect blend of modern living and outdoor adventure at The Asher, just a short ride from Holiday Park in Broward County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holiday Park Broward",
      "seo_description": "Explore apartments near Holiday Park in Broward County at The Asher. Enjoy modern amenities close to ample recreational opportunities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "mullins-park-nearby-apartments-north-lauderdale-344",
      "search_query": "Mullins Park close by apartments in North Lauderdale",
      "category": "Park",
      "h1_title": "Apartments Near Mullins Park",
      "h2_subtitle": "Find apartments in North Lauderdale close to Mullins Park. The Asher offers a perfect location with access to both leisure and comfort.",
      "page_copy": "The Asher in North Lauderdale places you conveniently close to Mullins Park, a vibrant destination for recreation and relaxation. Whether you enjoy sports activities, family picnics, or community events, living near Mullins Park offers a variety of ways to stay active and engaged in the community.\n\nOur community provides spacious one, two, and three-bedroom apartments that blend modern interiors with comfortable living. The Asher is equipped with resort-style amenities such as a refreshing pool, serene lake views, and a BBQ area, ideal for entertaining or unwinding. Plus, with a dedicated dog park, our pet-friendly environment ensures every resident, including the four-legged ones, feels at home. Discover the balance of vibrant park life and modern comfort at The Asher, close to Mullins Park in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mullins Park",
      "seo_description": "Discover The Asher's apartments near Mullins Park in North Lauderdale, offering modern amenities and perfect community access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "tradewinds-park-area-apartments-33068-931",
      "search_query": "Tradewinds Park area apartments 33068",
      "category": "Park",
      "h1_title": "Apartments Near Tradewinds Park 33068",
      "h2_subtitle": "Explore the charming apartments near Tradewinds Park in the 33068 area. The Asher offers a blend of comfort and convenience.",
      "page_copy": "Situated in the heart of North Lauderdale, The Asher provides an exceptional living experience close to Tradewinds Park in the 33068 area. Ideal for those who appreciate outdoor adventures, the park offers equestrian trails, sports fields, and scenic picnic areas, making it a beloved local destination.\n\nThe Asher features thoughtfully designed one, two, and three-bedroom apartments with contemporary finishes and spacious layouts. Our residents enjoy fantastic amenities including a community pool, a tranquil lake view, and BBQ facilities perfect for hosting friends and family gatherings. Our pet-friendly environment, complete with a dog park, ensures that all members of your family are welcome. Experience a vibrant lifestyle with comfort and accessibility at The Asher, conveniently positioned near Tradewinds Park in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tradewinds Park 33068",
      "seo_description": "Discover The Asher's apartments near Tradewinds Park in 33068. Enjoy modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5745554927648768",
      "source": "custom",
      "page_item_url": "cypress-park-adjacent-apartments-north-lauderdale-fl-210",
      "search_query": "Cypress Park adjacent apartments North Lauderdale FL",
      "category": "Park",
      "h1_title": "Apartments Near Cypress Park",
      "h2_subtitle": "Find the ideal apartments adjacent to Cypress Park in North Lauderdale, FL. Enjoy modern living with convenient park access.",
      "page_copy": "The Asher in North Lauderdale, FL, offers you the chance to live adjacent to the beautiful Cypress Park. Known for its lush greenery and recreational opportunities, Cypress Park provides an escape into nature with walking trails, sports facilities, and serene picnic spots, right at your doorstep.\n\nOur community features spacious and modern one, two, and three-bedroom apartments designed to cater to your every need. Residents benefit from top-tier amenities like refreshing lakeside views, a swimming pool, and a BBQ area perfect for entertaining. The dedicated dog park ensures that even your furry friends feel at home. Embrace the perfect blend of nature and urban lifestyle by choosing The Asher as your next living space, located conveniently near Cypress Park in North Lauderdale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
      "featured_image_media": {
        "alt_text": "Living room with dark teal accent wall, TV, sofa, coffee table, and sliding glass door.",
        "public_id": "019f6c11-0c03-77af-816e-56486e0fde76",
        "storage_key": "property/5745554927648768/019f6c11-0c03-77af-816e-56486e0fde76.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cypress Park",
      "seo_description": "Live near Cypress Park at The Asher in North Lauderdale, FL. Enjoy modern apartments and amenities close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2290"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2715580968"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5015181"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WMHDCKN"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8775017869"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f58c28903611f14b"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwno7zgvd2"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/b943d347-a1a1-4d51-94c7-b9b6e0eb5b13"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "754-318-3266"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkZ5bjJJVHNsTVJZM3RHSENPRnJKUVE9PSIsInZhbHVlIjoiOUVjdWZLNVZySXlENlFhTjZ5YU5WZz09IiwibWFjIjoiNzU2MGE1MWM2YWI3OTkzN2E5Yjg4YWVkYmM1ZmQ5NGM5YTk4N2I4MTExZjMxNTYzYTgyNzIxMTM2ZDc4MjAxMyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2290",
  "custom_repli_id": "2715580968",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a4e\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a4e\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5015181",
  "custom_google_gtm_id": "GTM-WMHDCKN",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8775017869",
  "custom_knock_community_id": "f58c28903611f14b",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rkwno7zgvd2",
  "custom_self_guided_tour_url": "https://selftournow.com/property/b943d347-a1a1-4d51-94c7-b9b6e0eb5b13",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "754-318-3266",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkZ5bjJJVHNsTVJZM3RHSENPRnJKUVE9PSIsInZhbHVlIjoiOUVjdWZLNVZySXlENlFhTjZ5YU5WZz09IiwibWFjIjoiNzU2MGE1MWM2YWI3OTkzN2E5Yjg4YWVkYmM1ZmQ5NGM5YTk4N2I4MTExZjMxNTYzYTgyNzIxMTM2ZDc4MjAxMyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "c708ee67-3997-4d6c-a992-23cd4d547ae5",
  "custom_audioeye_site_hash": "e06fe09b084b5993245e94563041bcc9"
};

export const generatedAt = '2026-11-03T20:31:59.239Z';
